var $a = Object.defineProperty, va = Object.defineProperties;
var qa = Object.getOwnPropertyDescriptors;
var he = Object.getOwnPropertySymbols;
var at = Object.prototype.hasOwnProperty, st = Object.prototype.propertyIsEnumerable;
var nt = (o, e, r) => e in o ? $a(o, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[e] = r, n = (o, e) => {
  for (var r in e || (e = {}))
    at.call(e, r) && nt(o, r, e[r]);
  if (he)
    for (var r of he(e))
      st.call(e, r) && nt(o, r, e[r]);
  return o;
}, T = (o, e) => va(o, qa(e));
var p = (o, e) => {
  var r = {};
  for (var t in o)
    at.call(o, t) && e.indexOf(t) < 0 && (r[t] = o[t]);
  if (o != null && he)
    for (var t of he(o))
      e.indexOf(t) < 0 && st.call(o, t) && (r[t] = o[t]);
  return r;
};

// src/base/Box/Box.tsx
import Ia from "react";

// src/lib/mosaiqStyled.ts
import wa, { css as io } from "styled-components";
var vo = (o, e, r, t) => e ? io`
    ${`${o}-${r}: ${typeof e == "string" ? e : `${t.mosaiq.spacing(e)}px`};`}
  ` : "", lt = (o, e, r) => typeof e == "number" ? io`
      ${`${o}: ${r.mosaiq.spacing(e)}px;`}
    ` : typeof e == "string" ? io`
      ${`${o}: ${e}px;`}
    ` : Array.isArray(e) ? io`
      ${`${o}: ${e.map(
  (t) => typeof t == "string" ? t : `${r.mosaiq.spacing(t)}px`
).join(" ")};`}
    ` : "", Ca = ({
  margin: o,
  marginTop: e,
  marginBottom: r,
  marginLeft: t,
  marginRight: i,
  padding: a,
  paddingTop: l,
  paddingBottom: s,
  paddingLeft: d,
  paddingRight: v,
  elevation: g,
  theme: f,
  onClick: u,
  disabled: h
}) => {
  let x = io``;
  return (o || e || r || t || i) && (x = io`
      ${lt("margin", o, f)}
      ${vo("margin", e, "top", f)}
      ${vo("margin", r, "bottom", f)}
      ${vo("margin", t, "left", f)}
      ${vo("margin", i, "right", f)}
    `), (a || l || s || d || v) && (x = io`
      ${x}
      ${lt("padding", a, f)}
      ${vo("padding", l, "top", f)}
      ${vo("padding", s, "bottom", f)}
      ${vo("padding", d, "left", f)}
      ${vo("padding", v, "right", f)}
    `), typeof g == "number" && f.mosaiq.elevation[g] && (x = io`
      ${x}
      box-shadow: ${f.mosaiq.elevation[g]};
    `), typeof u == "function" && !h && (x = io`
      ${x}
      cursor: pointer;
    `), h && (x = io`
      ${x}
      cursor: default;
    `), x;
}, c = (o) => wa(o)`
  ${(e) => Ca(e)}
`;

// src/base/Box/Box.styles.ts
import Ea, { css as mt } from "styled-components";

// src/utils.ts
import Sa from "lodash/kebabCase";
import ka from "lodash/uniqueId";

// src/theme/breakpoints.ts
var qo = {
  extraSmall: 576,
  small: 1024,
  medium: 1280,
  large: 1440,
  extraLarge: 1920
}, er = {
  extraSmall: 667,
  small: 740,
  medium: 844,
  large: 1024,
  extraLarge: 1180
};

// src/utils.ts
var N = (o, e, r) => {
  var t, i;
  return typeof e == "function" ? e(o) : r && (i = (t = o.theme[r]) == null ? void 0 : t[e]) != null ? i : e;
}, rr = ({ min: o, max: e }) => {
  if (o && e) {
    if (o === e)
      throw new Error("Same value is given for both min and max breakpoints");
    if (qo[o] > qo[e])
      return { min: e, max: o };
  }
  return { min: o, max: e };
}, pt = (o) => {
  switch (o) {
    case "xxlarge":
      return {
        variant: "title3"
      };
    case "xlarge":
      return {
        variant: "title4"
      };
    case "large":
      return {
        variant: "body2"
      };
    case "micro":
    case "small":
      return {
        variant: "body4"
      };
    default:
      return {
        variant: "body3"
      };
  }
}, wo = (o) => ka(Sa(o).substring(0, 10));

// src/base/Spacer/Spacer.styles.ts
import Ta, { css as Pa } from "styled-components";
function Uo(o, e) {
  return typeof e == "number" ? `${o.mosaiq.spacing(e)}px` : e;
}
var $e = Ta.div`
  ${({ theme: o, width: e, minWidth: r, maxWidth: t, height: i, minHeight: a, maxHeight: l, display: s, flex: d }) => Pa`
    display: ${s};
    flex: ${d};
    width: ${Uo(o, e)};
    min-width: ${Uo(o, r)};
    max-width: ${Uo(o, t)};
    height: ${Uo(o, i)};
    min-height: ${Uo(o, a)};
    max-height: ${Uo(o, l)};
  `}
`;

// src/base/Box/Box.styles.ts
var Ko = Ea($e)`
  ${({ theme: o, position: e, borderRadius: r }) => mt`
    position: ${e};
    border-radius: ${r && o.mosaiq.spacing(r) + "px"};
  `}

  background-color: ${(o) => N(o, o.backgroundColor)};

  ${(o) => o.border && mt`
      border: thin solid
        ${o.borderColor ? N(o, o.borderColor) : o.theme.mosaiq.colors.grey60};
    `}
`;

// src/base/Box/Box.tsx
var Ma = c((o) => /* @__PURE__ */ Ia.createElement(Ko, n({}, o))), tr = Ma;

// src/base/Control/Control.styles.ts
import ct, { css as ir } from "styled-components";
var ve = ct.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  min-width: ${({ theme: o }) => o.spacing(2)}px;
  min-height: ${({ theme: o }) => o.spacing(2)}px;
  max-width: ${({ theme: o }) => o.spacing(2)}px;
  max-height: ${({ theme: o }) => o.spacing(2)}px;
  border-radius: ${({ theme: o }) => o.spacing(0.5)}px;
  border: 1px solid ${({ theme: o }) => o.mosaiq.colors.grey60};

  svg {
    color: ${({ theme: o }) => o.mosaiq.colors.white};
    min-width: ${({ theme: o }) => o.spacing(1.5)}px;
    min-height: ${({ theme: o }) => o.spacing(1.5)}px;
    max-width: ${({ theme: o }) => o.spacing(1.5)}px;
    max-height: ${({ theme: o }) => o.spacing(1.5)}px;
  }
`, Co = ct.label`
  display: inline-flex;
  vertical-align: middle;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  user-select: none;

  input {
    opacity: 0;
    width: 0;
    height: 0;
    position: absolute;
  }

  ${({ hasLabel: o, theme: e, disabled: r, highlight: t }) => o && ir`
      padding: ${e.spacing(1)}px;
      border-radius: ${e.spacing(1)}px;

      ${t && ir`
        background-color: ${e.mosaiq.colors.grey};
      `}

      ${!r && ir`
        &:hover {
          background-color: ${e.mosaiq.colors.grey};
        }
      `}
    `}
`;

// src/base/Field/Field.styles.tsx
import dt from "react";
import qe, { css as to } from "styled-components";
import { CaretDown as La, LockSimple as Ba } from "phosphor-react";
var Xo = qe.span``, Lo = qe.div`
  display: flex;
  align-items: center;
  gap: ${({ theme: o, size: e }) => e === "large" ? o.spacing(1.5) : o.spacing(1)}px;
  padding: ${({ theme: o, size: e }) => e === "large" ? o.spacing(2) : o.spacing(1.5)}px;
  background: ${({ theme: o }) => o.mosaiq.colors.white};
  min-height: ${({ size: o, theme: e }) => o === "small" ? e.spacing(4) : o === "large" ? e.spacing(7) : e.spacing(5)}px;

  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
  border-radius: ${({ theme: o }) => o.spacing(1.25)}px;
  border-width: 2px;
  border-style: solid;
  border-color: ${({ theme: o }) => o.mosaiq.colors.grey60};

  transition: border-color 0.2s ease-out;

  ${({ borderless: o }) => o && to`
      border: none !important;
      outline: none !important;
      padding-left: 0 !important;
      min-height: ${({ theme: e }) => e.spacing(3)}px;
    `}

  ${({ readOnly: o }) => o && to`
      cursor: default;
    `}

  ${({ autoSize: o, size: e, theme: r }) => o ? to`
          flex-wrap: wrap;
          padding: ${({ theme: t }) => t.spacing(1)}px;
        ` : to`
          flex-wrap: nowrap;
          max-height: ${e === "small" ? r.spacing(3) : e === "large" ? r.spacing(6) : r.spacing(4)}px;
        `};

  ${({ size: o, theme: e }) => o === "small" ? e.mosaiq.typography.body4() : e.mosaiq.typography.body2()}

  input, span {
    font-family: ${({ theme: o }) => o.mosaiq.fonts.main};
    border: none;
    color: ${({ theme: o }) => o.mosaiq.colors.title};
    background-color: inherit;
    outline: none;
    flex-grow: 1;
    padding: 0;

    ${({ readOnly: o }) => o && to`
        cursor: default;
      `}

    ${({ size: o, theme: e }) => o === "small" ? e.mosaiq.typography.body4() : o === "large" ? e.mosaiq.typography.body2() : e.mosaiq.typography.body3()}

    &::placeholder, ${Xo} {
      color: ${({ theme: o }) => o.mosaiq.colors.placeholder};
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    input[type='number'] {
      -moz-appearance: textfield;
    }

    ${({ borderless: o, error: e }) => o && e && to`
        color: ${({ theme: r }) => r.mosaiq.colors.error};

        &::placeholder,
        ${Xo} {
          color: ${({ theme: r }) => r.mosaiq.colors.error};
        }
      `}
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }

  input[type='range'] {
    -webkit-appearance: none;
    appearance: none;
    background: transparent;
    cursor: pointer;
    width: 100%;
    transition: 0.3s;
    accent-color: ${({ theme: o }) => o.mosaiq.colors.grey80};
  }

  /* Removes default focus */
  input[type='range']:focus {
    outline: none;
  }

  input[type='range']::-webkit-slider-runnable-track {
    background-color: ${({ theme: o }) => o.mosaiq.colors.grey60};
    border-radius: 4px;
    height: 4px;
    border: none;
  }

  input[type='range']::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    margin-top: -4px;
    background-color: ${({ theme: o }) => o.mosaiq.colors.black};
    height: 12px;
    width: 12px;
    border-radius: 12px;
  }

  input[type='range']::-moz-range-track {
    background-color: ${({ theme: o }) => o.mosaiq.colors.white};
    border-radius: 6px;
    height: 6px;
    box-shadow: inset 0 0 0 1px ${({ theme: o }) => o.mosaiq.colors.grey60};
  }

  input[type='range']::-moz-range-thumb {
    margin-top: -4px;
    background-color: ${({ theme: o }) => o.mosaiq.colors.grey60};
    border-color: ${({ theme: o }) => o.mosaiq.colors.grey80};
    height: 12px;
    width: 12px;
    border-radius: 12px;
  }

  input:disabled {
    color: ${({ theme: o }) => o.mosaiq.colors.body};
  }

  ${({ theme: o, error: e, disabled: r, focus: t }) => e ? to`
        border-color: ${o.mosaiq.colors.error};
      ` : r ? to`
        background: ${o.mosaiq.colors.grey};
        border-color: ${o.mosaiq.colors.grey60};
      ` : t ? to`
        border-color: ${o.mosaiq.colors.black};
      ` : to`
      &:hover {
        border-color: ${o.mosaiq.colors.placeholder};
      }
    `}
`, Qo = qe.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme: o }) => o.spacing(0.5)}px;

  ${({ fullWidth: o }) => o && to`
      flex: 1;
      width: 100%;
      input {
        width: 100%;
      }
    `}

  & > label {
    display: inline-flex;
  }
`, Q = qe(
  ({ locked: o, className: e, disabled: r, size: t }) => r ? null : o ? /* @__PURE__ */ dt.createElement(Ba, { weight: "bold", width: t === "small" ? 14 : 16, className: e }) : /* @__PURE__ */ dt.createElement(La, { weight: "bold", width: t === "small" ? 14 : 16, className: e })
)`
  ${({ theme: o }) => o.mosaiq.typography.body2({ singleLine: !0 })};
  color: ${({ theme: o }) => o.mosaiq.colors.passive};
  transition: transform 100ms ease;
  transform: ${({ open: o, locked: e, heading: r }) => !e && `rotate(${r ? o ? 0 : 90 : +!!o * 180}deg)`};
`;

// src/base/Spacer/Spacer.tsx
import Aa from "react";
var Da = c(
  (r) => {
    var t = r, { children: o } = t, e = p(t, ["children"]);
    return /* @__PURE__ */ Aa.createElement($e, n({}, e));
  }
), Fa = Da;

// src/base/Flex/Flex.tsx
import Tt from "react";

// src/base/Flex/NativeFlex.tsx
import Ha from "react";

// src/base/Flex/Flex.styles.ts
import ft, { css as ne } from "styled-components";
var Wa = ({
  isNative: o,
  gap: e = 0,
  wrap: r = "nowrap",
  direction: t = "row",
  theme: i
}) => {
  let a = i.spacing(e);
  return r === "nowrap" || !o ? t === "column" ? ne`
        & > *:not(:last-child) {
          margin-bottom: ${a}px;
        }
      ` : t === "row-reverse" ? ne`
        & > *:not(:first-child) {
          margin-right: ${a}px;
        }
      ` : t === "column-reverse" ? ne`
        & > *:not(:first-child) {
          margin-bottom: ${a}px;
        }
      ` : ne`
      & > *:not(:last-child) {
        margin-right: ${a}px;
      }
    ` : ne`
      gap: ${a}px;
    `;
}, nr = ft(Ko)`
  display: ${({ inline: o }) => o ? "inline-flex" : "flex"};
  flex-direction: ${({ direction: o }) => o};
  flex-wrap: ${({ wrap: o }) => o};
  justify-content: ${({ justify: o }) => o};
  align-content: ${({ alignContent: o }) => o};
  align-items: ${({ alignItems: o }) => o};
  flex: ${({ flex: o }) => o};

  ${({ isNative: o, gap: e = 0, wrap: r = "nowrap", direction: t = "row", theme: i }) => e > 0 && Wa({
  isNative: o,
  gap: e,
  wrap: r,
  direction: t,
  theme: i
})}
`, ut = ft(nr)`
  & > * {
    ${({ theme: o, gaps: e }) => {
  let r = Object.keys(e), t = "";
  return r.length && r.forEach((i) => {
    var a, l;
    t = `
      ${t}

      &:nth-child(${i}) {
        margin-right: ${o.spacing((a = e[i].marginRight) != null ? a : 0)}px;
        margin-bottom: ${o.spacing((l = e[i].marginBottom) != null ? l : 0)}px;
      }
    `;
  }), t;
}}
  }
`;

// src/base/Flex/NativeFlex.tsx
var gt = c(
  (f) => {
    var u = f, {
      alignItems: o,
      alignContent: e,
      children: r,
      direction: t,
      gap: i,
      justify: a,
      wrap: l,
      isNative: s,
      inline: d,
      flex: v
    } = u, g = p(u, [
      "alignItems",
      "alignContent",
      "children",
      "direction",
      "gap",
      "justify",
      "wrap",
      "isNative",
      "inline",
      "flex"
    ]);
    return /* @__PURE__ */ Ha.createElement(
      nr,
      n({
        alignItems: o,
        alignContent: e,
        direction: t,
        gap: i,
        justify: a,
        isNative: s,
        wrap: l,
        inline: d,
        flex: v
      }, g),
      r
    );
  }
);
gt.displayName = "NativeFlex";
var xt = gt;

// src/base/Flex/NonnativeFlex.tsx
import * as no from "react";

// src/hooks/useWindowResize/useWindowResize.ts
import * as we from "react";
var Oa = () => {
  let [o, e] = we.useState(() => ({
    width: 0,
    height: 0
  })), r = () => {
    e({
      width: window.innerWidth,
      height: window.innerHeight
    });
  };
  return we.useEffect(() => (window.addEventListener("resize", r), r(), () => window.removeEventListener("resize", r)), []), o;
}, Ce = Oa;

// src/theme/index.tsx
import Qa, { useMemo as Ja } from "react";
import { ThemeProvider as Ya } from "styled-components";
import Za from "lodash/merge";

// src/theme/colors.ts
var za = {
  apricotPeach: "#FDD7CB",
  blackWhite: "#FFFEF8",
  coral: "#F87853",
  emerald: "#48C17A",
  emeraldWhite: "#E7F8EE",
  iceCold: "#AAF0E8",
  lavender: "#8E76DC",
  lavenderLight: "#EFEDFB",
  lavenderWhite: "#F4F1FF",
  maverick: "#E6D4DF",
  melrose: "#CABAFD",
  mineShaft: "#292929",
  moonRaker: "#ECEEFB",
  mould: "#C8F0D9",
  navajoWhite: "#FFE0AB",
  persianBlue: "#0057FF",
  plum: "#81265D",
  portage: "#CEDFFF",
  sandyBrown: "#FBB254",
  sandyHeath: "#FFF9EE",
  softPeach: "#FEEDE9",
  softPlum: "#FAF6F9",
  spray: "#1CFFE4",
  whiteIce: "#E8FFFC"
}, Na = {
  black: "#292929",
  white: "#FFFFFF",
  title: "#292929",
  body: "#595B60",
  passive: "#8D9097",
  placeholder: "#B9BBC1",
  error: "#F87853",
  warning: "#FBB254",
  success: "#6FCF97",
  action: "#0057FF",
  grey: "#F4F5F7",
  grey20: "#E7EAF0",
  grey40: "#E3E5E9",
  grey60: "#D3D6DF",
  grey80: "#B9BBC1"
}, bt = n(n({}, Na), za);

// src/theme/dimensions.ts
var _a = {
  entityPanelWidth: 353,
  maxReadingWidth: 800,
  maxContainerWidth: 1600,
  minModalWidth: 580,
  maxModalWidth: 900
}, yt = _a;

// src/theme/mediaQueries.ts
import {
  css as Se
} from "styled-components";
var Bo = (o) => {
  let { min: e, max: r } = rr(o), t = [];
  return e && t.push(`min-width: ${qo[e] + 1}px`), r && t.push(`max-width: ${qo[r]}px`), (i, ...a) => Se`
      @media (${t.join(" and ")}) {
        ${Se(i, ...a)};
      }
    `;
}, ja = (o) => {
  let { min: e, max: r } = rr(o), t = [];
  return e && t.push(`min-height: ${er[e] + 1}px`), r && t.push(`max-height: ${er[r]}px`), (i, ...a) => Se`
      @media (${t.join(" and ")}) {
        ${Se(i, ...a)};
      }
    `;
}, Ga = {
  screenSize: Bo,
  screenHeight: ja,
  extraSmallOnly: Bo({ max: "extraSmall" }),
  smallOnly: Bo({ min: "extraSmall", max: "small" }),
  mediumOnly: Bo({ min: "small", max: "medium" }),
  largeOnly: Bo({ min: "medium", max: "large" }),
  extraLargeOnly: Bo({ min: "large", max: "extraLarge" }),
  extraExtraLargeOnly: Bo({ min: "extraLarge" })
}, ht = Ga;

// src/theme/mixins.ts
import { css as ar } from "styled-components";
(function() {
  typeof window != "undefined" && CSS && "paintWorklet" in CSS && CSS.paintWorklet.addModule(
    // Paint API needs a path to a paint woklet module, so we build one on-the-fly
    URL.createObjectURL(
      new Blob(
        [
          `
          const drawSquircle = (ctx, geom, corners, radius, smooth, lineWidth, color) => {
            const defaultFill = color;
            const lineWidthOffset = lineWidth / 2;

            // OPEN LEFT-TOP CORNER
            ctx.beginPath();
            // ctx.lineTo(radius, lineWidthOffset);

            // TOP-RIGHT CORNER
            if (corners.has('top-right')) {
              ctx.lineTo(geom.width - radius, lineWidthOffset);
              ctx.bezierCurveTo(
                geom.width - radius / smooth,
                lineWidthOffset, // first bezier point
                geom.width - lineWidthOffset,
                radius / smooth, // second bezier point
                geom.width - lineWidthOffset,
                radius // last connect point
                );
            } else {
              ctx.lineTo(geom.width - lineWidthOffset, lineWidthOffset);
            }

            // BOTTOM-RIGHT CORNER
            if (corners.has('bottom-right')) {
              ctx.lineTo(geom.width - lineWidthOffset, geom.height - radius);
              ctx.bezierCurveTo(
                geom.width - lineWidthOffset,
                geom.height - radius / smooth, // first bezier point
                geom.width - radius / smooth,
                geom.height - lineWidthOffset, // second bezier point
                geom.width - radius,
                geom.height - lineWidthOffset // last connect point
              );
            } else {
              ctx.lineTo(geom.width - lineWidthOffset, geom.height - lineWidthOffset);
            }

            // BOTTOM-LEFT CORNER
            if (corners.has('bottom-left')) {
              ctx.lineTo(radius, geom.height - lineWidthOffset);
              ctx.bezierCurveTo(
                radius / smooth,
                geom.height - lineWidthOffset, // first bezier point
                lineWidthOffset,
                geom.height - radius / smooth, // second bezier point
                lineWidthOffset,
                geom.height - radius // last connect point
              );
            } else {
              ctx.lineTo(lineWidthOffset, geom.height - lineWidthOffset);
            }

            // CLOSE LEFT-TOP CORNER
            if (corners.has('top-left')) {
              ctx.lineTo(lineWidthOffset, radius);
              ctx.bezierCurveTo(
                lineWidthOffset,
                radius / smooth, // first bezier point
                radius / smooth,
                lineWidthOffset, // second bezier point
                radius,
                lineWidthOffset // last connect point
              );
            } else {
              ctx.lineTo(lineWidthOffset, lineWidthOffset);
            }

            ctx.closePath();
          
            if (lineWidth) {
              ctx.strokeStyle = defaultFill;
              ctx.lineWidth = lineWidth;
              ctx.stroke();
            } else {
              ctx.fillStyle = defaultFill;
              ctx.fill();
            }
          };
          
          if (typeof registerPaint !== "undefined") {
            class SquirclePainter {
              static get contextOptions() {
                return { alpha: true };
              }
              static get inputProperties() {
                return [
                  "--squircle-radius",
                  "--squircle-smooth",
                  "--squircle-outline",
                  "--squircle-fill",
                  "--squircle-ratio",
                  "--squircle-corners",
                ];
              }
          
              paint(ctx, geom, properties) {
                const customRatio = properties.get("--squircle-ratio");
                const smoothRatio = 10;
                const distanceRatio = parseFloat(customRatio)
                  ? parseFloat(customRatio)
                  : 1.8;
                const squircleSmooth = parseFloat(
                  properties.get("--squircle-smooth") * smoothRatio
                );
                const squircleRadius =
                  parseInt(properties.get("--squircle-radius"), 10) * distanceRatio;
                const squrcleOutline = parseFloat(
                  properties.get("--squircle-outline"),
                  10
                );
                const squircleColor = properties
                  .get("--squircle-fill")
                  .toString()
                  .replace(/s/g, "");
          
                const isSmooth = () => {
                  if (typeof properties.get("--squircle-smooth")[0] !== "undefined") {
                    if (squircleSmooth === 0) {
                      return 1;
                    }
                    return squircleSmooth;
                  } else {
                    return 10;
                  }
                };
          
                const isOutline = () => {
                  if (squrcleOutline) {
                    return squrcleOutline;
                  } else {
                    return 0;
                  }
                };
          
                const isColor = () => {
                  if (squircleColor) {
                    return squircleColor;
                  } else {
                    return "#2f2f2f";
                  }
                };

                const corners = new Set(properties.get('--squircle-corners')?.[0]?.split(' '));
          
                if (squircleRadius < geom.width / 2 && squircleRadius < geom.height / 2) {
                  drawSquircle(
                    ctx,
                    geom,
                    corners,
                    squircleRadius,
                    isSmooth(),
                    isOutline(),
                    isColor()
                  );
                } else {
                  drawSquircle(
                    ctx,
                    geom,
                    corners,
                    Math.min(geom.width / 2, geom.height / 2),
                    isSmooth(),
                    isOutline(),
                    isColor()
                  );
                }
              }
            }
  
            registerPaint("squircle", SquirclePainter);
          }
          `
        ],
        { type: "text/javascript" }
      )
    )
  );
})();
var Ra = (o) => {
  var e, r, t, i, a, l, s, d, v;
  return ar`
  @supports (mask-image: paint(id)) or (-webkit-mask-image: paint(id)) {
    mask-image: paint(squircle);
    --squircle-smooth: 0.6;
    --squircle-radius: ${(e = o == null ? void 0 : o.borderRadius) != null ? e : 8}px;
    --squircle-outline: ${(r = o == null ? void 0 : o.border) != null ? r : 0}px;
    --squircle-corners: ${((t = o == null ? void 0 : o.corners) != null ? t : ["top-left", "top-right", "bottom-left", "bottom-right"]).join(" ")};

    &:focus-visible {
      mask-image: none;
    }
  }

  @supports not ((mask-image: paint(id)) or (-webkit-mask-image: paint(id))) {
    border-radius: ${(i = o == null ? void 0 : o.borderRadius) != null ? i : 0}px;
    ${((a = o == null ? void 0 : o.corners) == null ? void 0 : a.length) && ar`
      border-top-left-radius: ${+o.corners.includes("top-left") * ((l = o.borderRadius) != null ? l : 0)}px;
      border-top-right-radius: ${+o.corners.includes("top-right") * ((s = o.borderRadius) != null ? s : 0)}px;
      border-bottom-left-radius: ${+o.corners.includes("bottom-left") * ((d = o.borderRadius) != null ? d : 0)}px;
      border-bottom-right-radius: ${+o.corners.includes("bottom-right") * ((v = o.borderRadius) != null ? v : 0)}px;
    `};
  }
`;
}, Va = `
  html,
  body,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  video
`, Ua = (o) => ar`
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.98) 60%);
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: ${o};
  `, $t = { squircle: Ra, proseTags: Va, listShimmer: Ua };

// src/theme/typography.ts
import { css as J } from "styled-components";
var vt = {
  title1: (o) => J`
    font-family: ${({ theme: e }) => e.mosaiq.fonts.main};
    font-weight: ${(o == null ? void 0 : o.fontWeight) || 400};
    font-size: 56px;
    line-height: 64px;
  `,
  title2: (o) => J`
    font-family: ${({ theme: e }) => e.mosaiq.fonts.main};
    font-weight: ${(o == null ? void 0 : o.fontWeight) || 400};
    font-size: 48px;
    line-height: 56px;
  `,
  title3: (o) => J`
    font-family: ${({ theme: e }) => e.mosaiq.fonts.main};
    font-weight: ${(o == null ? void 0 : o.fontWeight) || 400};
    font-size: 32px;
    line-height: 40px;
  `,
  title4: (o) => J`
    font-family: ${({ theme: e }) => e.mosaiq.fonts.main};
    font-weight: ${(o == null ? void 0 : o.fontWeight) || 400};
    font-size: 24px;
    line-height: 32px;
  `,
  title5: (o) => J`
    font-family: ${({ theme: e }) => e.mosaiq.fonts.main};
    font-weight: ${(o == null ? void 0 : o.fontWeight) || 400};
    font-size: 20px;
    line-height: 24px;
  `,
  title6: (o) => J`
    font-family: ${({ theme: e }) => e.mosaiq.fonts.main};
    font-weight: ${(o == null ? void 0 : o.fontWeight) || 400};
    font-size: 16px;
    line-height: 20px;
  `,
  title7: (o) => J`
    font-family: ${({ theme: e }) => e.mosaiq.fonts.main};
    font-weight: ${(o == null ? void 0 : o.fontWeight) || 400};
    font-size: 12px;
    line-height: 16px;
  `,
  body1: (o) => J`
    font-family: ${({ theme: e }) => e.mosaiq.fonts.main};
    font-weight: ${(o == null ? void 0 : o.fontWeight) || 400};
    font-size: 18px;
    line-height: ${o != null && o.singleLine ? 22 : 28}px;
  `,
  body2: (o) => J`
    font-family: ${({ theme: e }) => e.mosaiq.fonts.main};
    font-weight: ${(o == null ? void 0 : o.fontWeight) || 400};
    font-size: 16px;
    line-height: ${o != null && o.singleLine ? 20 : 24}px;
  `,
  body3: (o) => J`
    font-family: ${({ theme: e }) => e.mosaiq.fonts.main};
    font-weight: ${(o == null ? void 0 : o.fontWeight) || 400};
    font-size: 14px;
    line-height: ${o != null && o.singleLine ? 18 : 24}px;
  `,
  body4: (o) => J`
    font-family: ${({ theme: e }) => e.mosaiq.fonts.main};
    font-weight: ${(o == null ? void 0 : o.fontWeight) || 400};
    font-size: 12px;
    line-height: ${o != null && o.singleLine ? 16 : 20}px;
  `,
  body5: (o) => J`
    font-family: ${({ theme: e }) => e.mosaiq.fonts.main};
    font-weight: ${(o == null ? void 0 : o.fontWeight) || 400};
    font-size: 10px;
    line-height: ${o != null && o.singleLine ? 12 : 14}px;
  `
};

// src/theme/zIndexes.ts
var qt = /* @__PURE__ */ (($) => ($.TOP_BAR = "topBar", $.FEED = "feed", $.NAV_SIDEBAR = "navsidebar", $.APP_DRAWER = "appDrawer", $.NAV_BAR = "navbar", $.VIEW_MODAL = "viewModal", $.SIDEBAR = "sidebar", $.IMAGE_ZOOM = "imagezoom", $.MODAL = "modal", $.MEGA_MENU = "megaMenu", $.NOTIFICATIONS_MENU = "notificationsMenu", $.QUICK_SEARCH = "quicksearch", $.ERROR_MODAL = "errorModal", $.TOAST = "toast", $.TOUR = "tour", $))(qt || {}), Ka = (o) => o.reduce(
  (e, r, t) => T(n({}, e), {
    [r]: (t + 1) * 100
  }),
  {}
), Xa = Ka(Object.values(qt)), wt = Xa;

// src/theme/index.tsx
var R = {
  breakpoints: qo,
  colors: bt,
  dimensions: yt,
  fonts: {
    main: "'Aeonik', sans-serif"
  },
  spacing: (o) => o * 8,
  elevation: {
    1: "0px 1px 3px rgba(0, 0, 0, 0.1)",
    2: "0px 0px 10px rgba(0, 0, 0, 0.05), 0px 5px 10px rgba(0, 0, 0, 0.05), 0px 2px 4px rgba(0, 0, 0, 0.05), 0px 10px 20px rgba(0, 0, 0, 0.05)"
  },
  mediaQueries: ht,
  mixins: $t,
  typography: vt,
  zIndexes: wt
}, ud = ({
  children: o,
  extras: e
}) => {
  let r = Ja(() => Za(R, e), [e]);
  return /* @__PURE__ */ Qa.createElement(Ya, { theme: T(n({}, r), { mosaiq: R }) }, o);
};

// src/base/Flex/NonnativeFlex.tsx
var os = (o, e) => {
  let r = {};
  if (!e)
    return r;
  let t = Object.keys(o);
  return t && (t.length === 1 ? o[1].forEach((i, a) => {
    r = T(n({}, r), {
      [i]: {
        marginRight: o[1].length === a + 1 ? 0 : e
      }
    });
  }) : t.forEach((i) => {
    o[i].forEach((a, l) => {
      r = T(n({}, r), {
        [a]: {
          marginRight: o[i].length === l + 1 ? 0 : e,
          marginBottom: parseInt(i, 10) === t.length ? 0 : e
        }
      });
    });
  })), r;
}, Ct = c(
  (g) => {
    var f = g, {
      wrap: o,
      gap: e,
      direction: r,
      alignItems: t,
      alignContent: i,
      justify: a,
      inline: l,
      children: s,
      flex: d
    } = f, v = p(f, [
      "wrap",
      "gap",
      "direction",
      "alignItems",
      "alignContent",
      "justify",
      "inline",
      "children",
      "flex"
    ]);
    let u = no.useRef(), h = Ce(), [x, $] = no.useState({}), L = no.useMemo(() => os(x, e), [x]);
    return no.useEffect(() => {
      var b, w, q;
      if (!e || !u.current)
        return;
      let { width: E } = (b = u == null ? void 0 : u.current) == null ? void 0 : b.getBoundingClientRect(), M = {}, C = 1, I = 0, m = Array.from((q = (w = u == null ? void 0 : u.current) == null ? void 0 : w.children) != null ? q : []);
      m.forEach((P, B) => {
        var F;
        let y = P.getBoundingClientRect(), k = (F = m == null ? void 0 : m[B + 1]) == null ? void 0 : F.getBoundingClientRect();
        if (I += (y == null ? void 0 : y.width) + R.spacing(e), M[C] ? M[C] = [...M[C], B + 1] : M[C] = [B + 1], r != null && r.includes("column")) {
          C += 1;
          return;
        }
        o !== "nowrap" && (I > E || I + (k == null ? void 0 : k.width) > E) && (C += 1, I = 0);
      }), $(M);
    }, [u.current, h]), /* @__PURE__ */ no.createElement(
      ut,
      n({
        ref: u,
        alignItems: t,
        alignContent: i,
        direction: r,
        gaps: L,
        justify: a,
        wrap: o,
        inline: l,
        flex: d,
        isNative: !1
      }, v),
      s
    );
  }
);
Ct.displayName = "NonnativeFlex";
var St = Ct;

// src/base/Flex/utils.ts
function kt() {
  if (typeof window == "undefined")
    return new Error("window is undefined");
  let o = window.navigator.userAgent.toLowerCase(), e = {
    chrome: /chrome\/([\d.]+)/,
    safari: /version\/([\d.]+).*safari/,
    firefox: /firefox\/([\d.]+)/,
    edge: /edge\/([\d.]+)/,
    opera: /opr\/([\d.]+)/
  };
  for (let [r, t] of Object.entries(e)) {
    let i = o.match(t);
    if (i)
      return { name: r, version: i[1] };
  }
  return new Error("Browser not detected");
}

// src/base/Flex/Flex.tsx
var lr = !1, sr = kt(), Pt, ke, Et;
if (!(sr instanceof Error)) {
  let o = sr.name, e = parseFloat((Pt = sr.version) != null ? Pt : "");
  lr = !!((Et = (ke = window == null ? void 0 : window.CSS) == null ? void 0 : ke.supports) != null && Et.call(ke, "gap", "0px")) && !(o === "safari" && e < 14.1 || o === "opera" && e < 70);
}
var It = c(
  (a) => {
    var l = a, { wrap: o = "nowrap", gap: e = 0, inline: r = !1, as: t } = l, i = p(l, ["wrap", "gap", "inline", "as"]);
    return o === "nowrap" || lr ? /* @__PURE__ */ Tt.createElement(
      xt,
      n({
        forwardedAs: t,
        gap: e,
        wrap: o,
        isNative: lr,
        inline: r
      }, i)
    ) : /* @__PURE__ */ Tt.createElement(St, n({ forwardedAs: t, gap: e, wrap: o, inline: r }, i));
  }
);
It.displayName = "Flex";
var fo = It;

// src/theme/global.ts
import { createGlobalStyle as es } from "styled-components";
var Dd = es`
  *,
  &:after,
  &:before {
    box-sizing: border-box;
  }

  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  html,
  body {
    width: 100%;
    font-family: ${({ theme: o }) => o.mosaiq.fonts.main};
    overscroll-behavior: none;
  }

  /* HTML5 display-role reset for older browsers */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }

  body {
    line-height: 1;
  }

  ol,
  ul {
    list-style: none;
  }

  blockquote,
  q {
    quotes: none;
  }

  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  a {
    text-decoration: none;
  }

  strong {
    font-weight: bold;
  }

  em {
    font-style: italic;
  }

  body,
  p,
  a {
    ${({ theme: o }) => o.mosaiq.typography.body1()}; 
    color: ${({ theme: o }) => o.mosaiq.colors.title};
  }

  h1 {
    ${({ theme: o }) => o.mosaiq.typography.title1()};
  }

  h2 {
    ${({ theme: o }) => o.mosaiq.typography.title2()};
  }

  h3 {
    ${({ theme: o }) => o.mosaiq.typography.title3()};
  }

  h4 {
    ${({ theme: o }) => o.mosaiq.typography.title4()};
  }

  h5 {
    ${({ theme: o }) => o.mosaiq.typography.title5()};
  }

  h6 {
    ${({ theme: o }) => o.mosaiq.typography.title6()};
  }

  [data-rsbs-overlay],
  [data-rsbs-backdrop],
  [data-rsbs-root]:after {
    z-index: 10001 !important;  // sorry for !important, but there is no workaround. 
  }
`;

// src/components/Accordion/Accordion.tsx
import Te, { useEffect as ns, useState as as } from "react";

// src/components/Accordion/Accordion.styles.ts
import ae from "styled-components";
var Mt = ae.div``, Lt = ae(Ko).attrs({ forwardedAs: "details" })``, Bt = ae.summary`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  list-style: none;

  &::-webkit-details-marker {
    display: none;
  }
`, At = ae.div`
  display: ${({ $isOpen: o }) => o ? "block" : "none"};
  transition: display 200ms ease-out;
`, zd = ae(fo).attrs({
  width: 3,
  height: 3,
  justify: "center",
  alignItems: "center",
  borderRadius: 0.8
})`
  background-color: ${({ theme: o, open: e }) => e ? o.colors.grey60 : o.colors.grey20};

  & > svg {
    transition: transform 200ms ease-out;
    ${({ open: o }) => o && "transform: rotate(180deg)"}
  }
`;

// src/components/Accordion/AccordionItem.tsx
import Dt, { cloneElement as rs, useEffect as ts, useState as is } from "react";
var Ft = c(
  (a) => {
    var l = a, { isDefaultOpen: o = !1, onToggle: e, header: r, children: t } = l, i = p(l, ["isDefaultOpen", "onToggle", "header", "children"]);
    let [s, d] = is(o), v = (g) => {
      d((f) => (e == null || e(!f, g), !f));
    };
    return ts(() => {
      d(o);
    }, [o]), /* @__PURE__ */ Dt.createElement(Lt, n({}, i), rs(r(s), { onClick: v }), /* @__PURE__ */ Dt.createElement(At, { $isOpen: s }, t));
  }
);

// src/components/Accordion/Accordion.tsx
function Wt(o, e, r) {
  return typeof o == "number" ? [o] : Array.isArray(o) ? o : o === !0 ? e ? [0] : r.map((t, i) => i) : [];
}
var ss = c(
  (l) => {
    var s = l, { items: o, exclusive: e = !1, defaultOpen: r, innerRef: t, summaryProps: i } = s, a = p(s, ["items", "exclusive", "defaultOpen", "innerRef", "summaryProps"]);
    let [d, v] = as(
      Wt(r, e, o)
    ), g = (f, u) => {
      u.preventDefault(), d.includes(f) ? v(e ? [] : d.filter((h) => h !== f)) : v(e ? [f] : [...d, f]);
    };
    return ns(() => {
      v(Wt(r, e, o));
    }, [r]), /* @__PURE__ */ Te.createElement(Mt, n({ ref: t }, a), o.map((f, u) => {
      let h = e ? u === d[0] : d.includes(u);
      return /* @__PURE__ */ Te.createElement(
        Ft,
        {
          key: u,
          isDefaultOpen: h,
          onToggle: (x, $) => {
            g(u, $);
          },
          header: () => /* @__PURE__ */ Te.createElement(Bt, n({}, i), f.summary, !!f.content && /* @__PURE__ */ Te.createElement(Q, { open: h }))
        },
        f.content
      );
    }));
  }
), ls = ss;

// src/components/Autocomplete/Autocomplete.tsx
import To, {
  Children as Ls,
  cloneElement as ni,
  isValidElement as br,
  useCallback as Bs,
  useEffect as ai,
  useRef as As,
  useState as si
} from "react";
import Ds from "@tippyjs/react/headless";

// src/components/Input/Input.tsx
import ao from "react";

// src/components/Typography/Typography.tsx
import cs, { useMemo as ds } from "react";

// src/components/Typography/Typography.styles.ts
import ps, { css as So } from "styled-components";
import { ellipsis as ms } from "polished";
var Ht = ps.div`
  font-family: ${({ theme: o }) => o.mosaiq.fonts.main};
  color: ${({ theme: o, color: e }) => {
  var r, t;
  return (t = (r = o.mosaiq.colors[e]) != null ? r : e) != null ? t : "inherit";
}};

  ${({ whiteSpace: o }) => o ? So`
          white-space: ${o};
        ` : void 0};

  ${({ theme: o, variant: e, fontWeight: r, ellipsis: t }) => o.mosaiq.typography[e]({ fontWeight: r, singleLine: (t == null ? void 0 : t.lines) === 1 })};
  ${({ wordBreak: o }) => o ? So`
          word-break: ${o};
          hyphens: auto;
        ` : void 0};
  ${({ ellipsis: o }) => o && Object.keys(o).length ? So`
          ${ms(o.width, o.lines)};
        ` : void 0};
  ${({ italic: o }) => o ? So`
          font-style: italic;
        ` : void 0};
  ${({ textAlign: o }) => o ? So`
          text-align: ${o};
        ` : void 0};
  ${({ textTransform: o }) => o ? So`
          text-transform: ${o};
        ` : void 0};
  ${({ textDecoration: o }) => o ? So`
          text-decoration: ${o};
        ` : void 0};
  ${({ link: o }) => o ? So`
          text-decoration: underline;
          cursor: pointer;
        ` : void 0};

  strong {
    font-weight: 600;
  }
`;

// src/components/Typography/Typography.tsx
var Ot = c(
  (l) => {
    var s = l, { children: o, element: e = "div", link: r, variant: t = "body1", innerRef: i } = s, a = p(s, ["children", "element", "link", "variant", "innerRef"]);
    let d = ds(() => {
      switch (t) {
        case "title1":
          return "h1";
        case "title2":
          return "h2";
        case "title3":
          return "h3";
        case "title4":
          return "h4";
        case "title5":
          return "h5";
        case "title6":
          return "h6";
        default:
          return e;
      }
    }, [e]);
    return /* @__PURE__ */ cs.createElement(
      Ht,
      n({
        as: d,
        ref: i,
        link: r || d === "a",
        variant: t
      }, a),
      o
    );
  }
);
Ot.displayName = "Typography";
var D = Ot;

// src/components/Label/Label.tsx
import fs from "react";
var us = c(
  (t) => {
    var i = t, { children: o, color: e = "title" } = i, r = p(i, ["children", "color"]);
    return /* @__PURE__ */ fs.createElement(D, n({ forwardedAs: "span", variant: "body4", fontWeight: 500, color: e }, r), o);
  }
), uo = us;

// src/components/Input/Input.styles.ts
import gs from "styled-components";
var zt = Qo, Nt = gs.label`
  ${({ labelEndAdornment: o }) => o && "align-items: center;"}
`, _t = c(Lo);

// src/components/Input/Input.tsx
var jt = c(
  (M) => {
    var C = M, {
      innerRef: o,
      label: e,
      helperText: r,
      autoSize: t = !1,
      autoFocus: i = !1,
      disabled: a = !1,
      error: l = !1,
      required: s = !1,
      borderless: d = !1,
      fullWidth: v = !1,
      labelEndAdornment: g,
      startAdornment: f,
      endAdornment: u,
      placeholder: h,
      inputProps: x = {},
      inputFieldProps: $ = {},
      size: L
    } = C, E = p(C, [
      "innerRef",
      "label",
      "helperText",
      "autoSize",
      "autoFocus",
      "disabled",
      "error",
      "required",
      "borderless",
      "fullWidth",
      "labelEndAdornment",
      "startAdornment",
      "endAdornment",
      "placeholder",
      "inputProps",
      "inputFieldProps",
      "size"
    ]);
    let [I] = ao.useState(wo(e)), [m, b] = ao.useState(i);
    return /* @__PURE__ */ ao.createElement(zt, n({ ref: o, fullWidth: v }, E), !!e && /* @__PURE__ */ ao.createElement(Nt, { labelEndAdornment: g, htmlFor: I }, /* @__PURE__ */ ao.createElement(uo, { color: a ? "placeholder" : "body" }, e, s && /* @__PURE__ */ ao.createElement(ao.Fragment, null, " *")), g), /* @__PURE__ */ ao.createElement(
      _t,
      n({
        $type: x.type,
        readOnly: x == null ? void 0 : x.readOnly,
        disabled: a,
        error: l,
        focus: m,
        autoSize: t,
        borderless: d,
        size: L,
        onClick: (w) => {
          var q;
          return (q = w.target.querySelector("input")) == null ? void 0 : q.focus();
        }
      }, $),
      f,
      /* @__PURE__ */ ao.createElement(
        "input",
        T(n({
          placeholder: h
        }, x), {
          id: e ? I : void 0,
          disabled: a,
          autoFocus: i,
          onFocus: (w) => {
            var q;
            b(!0), (q = x == null ? void 0 : x.onFocus) == null || q.call(x, w);
          },
          onBlur: (w) => {
            var q;
            b(!1), (q = x == null ? void 0 : x.onBlur) == null || q.call(x, w);
          }
        })
      ),
      u
    ), !!r && /* @__PURE__ */ ao.createElement(
      D,
      {
        variant: "body4",
        color: l ? "error" : a ? "placeholder" : "passive"
      },
      r
    ));
  }
);
jt.displayName = "Input";
var pr = jt;

// src/components/ListItem/ListItem.tsx
import Ao, { cloneElement as xs, useMemo as Ie } from "react";

// src/components/ListItem/ListItem.styles.tsx
import Ee, { css as Y } from "styled-components";
var Gt = Ee.span`
  align-self: ${({ align: o }) => o};
  display: flex;
`, mr = Ee.span`
  display: flex;
  flex-direction: column;
  gap: ${({ theme: o }) => o.spacing(0.5)}px;
  min-width: 0;
  overflow: hidden;
`, Pe = Ee.span`
  display: flex;
  align-items: center;
  margin-left: auto;
  padding-left: ${({ theme: o }) => o.spacing(1)}px;

  & > * {
    margin-left: ${({ theme: o }) => o.spacing(1)}px;
  }
`, Rt = Ee.span`
  max-width: 100%;

  ${({ inline: o }) => o ? Y`
          display: inline-flex;
          width: max-content;
        ` : Y`
          display: flex;
          width: 100%;
        `}

  align-items: center;

  ${({ theme: o, size: e, singleLine: r }) => {
  switch (e) {
    case "small":
      return Y`
          padding: ${o.spacing(r ? 1 : 1.5)}px;
          border-radius: ${o.spacing(0.75)}px;
        `;
    case "large":
      return Y`
          padding: ${o.spacing(1.5)}px;
          border-radius: ${o.spacing(1.5)}px;
        `;
    default:
      return Y`
          padding: ${o.spacing(r ? 1 : 1.5)}px;
          border-radius: ${o.spacing(1)}px;
        `;
  }
}}

  ${({ active: o, selected: e }) => e ? Y`
          background-color: ${({ theme: r }) => r.mosaiq.colors.grey40};
        ` : o && Y`
          background-color: ${({ theme: r }) => r.mosaiq.colors.grey};
        `}

  ${({ disabled: o }) => o && Y`
      pointer-events: none;
      opacity: 0.5;
    `}

  ${({ theme: o, hasAvatar: e, size: r }) => e && Y`
      ${mr} {
        margin-left: ${o.spacing(r === "small" ? 1 : 1.5)}px;
      }
    `}

    ${({ actionsOnlyVisibleOnHover: o }) => o && Y`
      ${Pe} {
        opacity: 0;
        visibility: hidden;
        padding: 0;
        margin: 0;
        width: 0;

        & > * {
          margin: 0;
        }
      }
    `}

  &:hover {
    background-color: ${({ theme: o, selected: e }) => e ? o.mosaiq.colors.grey40 : o.mosaiq.colors.grey};

    ${({ actionsOnlyVisibleOnHover: o }) => o && Y`
        ${Pe} {
          opacity: 1;
          visibility: visible;
          margin-left: auto;
          padding-left: ${({ theme: e }) => e.spacing(1)}px;
          width: initial;

          & > * {
            margin-left: ${({ theme: e }) => e.spacing(1)}px;
          }
        }
      `}
  }

  ${({ onClick: o }) => typeof o == "function" && Y`
      cursor: pointer;

      &:active {
        background-color: ${({ theme: e }) => e.mosaiq.colors.grey40};
      }
    `}
`;

// src/components/ListItem/ListItem.tsx
var bs = c(
  (L) => {
    var E = L, {
      avatar: o,
      primaryText: e,
      primaryTextProps: r,
      secondaryText: t,
      secondaryTextProps: i,
      tertiaryText: a,
      tertiaryTextProps: l,
      primaryAction: s,
      secondaryAction: d,
      size: v = "regular",
      active: g = !1,
      disabled: f = !1,
      inline: u = !1,
      actionsOnlyVisibleOnHover: h = !1,
      innerRef: x
    } = E, $ = p(E, [
      "avatar",
      "primaryText",
      "primaryTextProps",
      "secondaryText",
      "secondaryTextProps",
      "tertiaryText",
      "tertiaryTextProps",
      "primaryAction",
      "secondaryAction",
      "size",
      "active",
      "disabled",
      "inline",
      "actionsOnlyVisibleOnHover",
      "innerRef"
    ]);
    let M = Ie(
      () => n({
        color: "body",
        variant: v === "small" ? "body3" : "body2",
        ellipsis: { lines: 1 }
      }, r != null ? r : {}),
      [r, v]
    ), C = Ie(
      () => n({
        color: "passive",
        variant: "body4",
        ellipsis: { lines: 1 }
      }, i != null ? i : {}),
      [i]
    ), I = Ie(
      () => n({
        color: "body",
        variant: v === "small" ? "body4" : "body3"
      }, l != null ? l : {}),
      [l]
    ), m = Ie(() => {
      var b;
      if ((b = o == null ? void 0 : o.props) != null && b.size)
        return o.props.size;
      switch (v) {
        case "small":
          return "micro";
        case "large":
          return "regular";
        default:
          return "small";
      }
    }, [v, o]);
    return /* @__PURE__ */ Ao.createElement(
      Rt,
      n({
        ref: x,
        hasAvatar: !!o,
        size: v,
        active: g,
        disabled: f,
        inline: u,
        actionsOnlyVisibleOnHover: h,
        singleLine: !t
      }, $),
      !!o && /* @__PURE__ */ Ao.createElement(Gt, { align: a ? "baseline" : "center" }, xs(o, {
        size: m
      })),
      (e || t) && /* @__PURE__ */ Ao.createElement(mr, null, e && (typeof e == "string" ? /* @__PURE__ */ Ao.createElement(D, n({ "data-testid": "listItemPrimaryText" }, M), e) : e), t && (typeof t == "string" ? /* @__PURE__ */ Ao.createElement(D, n({ "data-testid": "listItemSecondayText" }, C), t) : t), a && /* @__PURE__ */ Ao.createElement(D, n({ "data-testid": "listItemTertiaryText" }, I), a)),
      (!!s || !!d) && /* @__PURE__ */ Ao.createElement(Pe, null, d, s)
    );
  }
), _ = bs;

// src/components/MenuItem/MenuItem.tsx
import Do, { useEffect as Cs, useRef as xr, Children as Ss, cloneElement as ks } from "react";
import { CaretRight as Ts } from "phosphor-react";

// src/components/OverflowMenu/OverflowMenu.tsx
import hs from "@tippyjs/react/headless";
import gr, {
  Children as $s,
  cloneElement as vs,
  isValidElement as qs,
  useEffect as ws,
  useState as Jt
} from "react";

// src/components/Menu/Menu.tsx
import dr, { useEffect as Me, useRef as fr, useState as Kt } from "react";

// src/components/Menu/Menu.styles.ts
import cr, { css as Vt } from "styled-components";
var go = cr.div`
  box-shadow: ${({ theme: o }) => o.mosaiq.elevation[2]};
  border-radius: ${({ theme: o }) => o.mosaiq.spacing(1.5)}px;
  border: 1px solid ${({ theme: o }) => o.mosaiq.colors.grey20};
  width: 100%;
  overflow: auto;
  background-color: ${({ theme: o }) => o.mosaiq.colors.white};

  ::-webkit-scrollbar {
    width: ${({ theme: o }) => o.mosaiq.spacing(2)}px;
  }

  ::-webkit-scrollbar-thumb {
    border: ${({ theme: o }) => o.mosaiq.spacing(0.5)}px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 9999px;
    background-color: ${({ theme: o }) => o.mosaiq.colors.grey20};
  }
`, ko = cr.div`
  position: relative;
  width: max-content;
  max-width: ${({ maxWidth: o }) => o && `${o}px`};
  min-width: ${({ minWidth: o }) => o && `${o}px`};
  outline: none;
  width: 100%;

  ${go} {
    max-height: ${({ maxHeight: o }) => o}px;
    max-width: ${({ maxWidth: o }) => o && `${o}px`};

    ${({ theme: o, hasShimmer: e }) => e ? Vt`
            padding: ${o.mosaiq.spacing(1)}px ${o.mosaiq.spacing(1)}px
              ${o.mosaiq.spacing(4)}px;
          ` : Vt`
            padding: ${o.mosaiq.spacing(1)}px;
          `}
  }
`, Ut = cr.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.98) 75%);
  height: ${({ theme: o }) => o.mosaiq.spacing(6)}px;
  border-radius: ${({ theme: o }) => `0px 0px ${o.mosaiq.spacing(1.5)}px ${o.mosaiq.spacing(1.5)}px`};
  z-index: 10;
  pointer-events: none;
`;

// src/components/Menu/Menu.tsx
var Xt = c(
  (g) => {
    var f = g, {
      children: o,
      maxHeight: e = 304,
      maxWidth: r,
      minWidth: t,
      innerRef: i,
      autoFocus: a = !0,
      hideShimmer: l = !1,
      autoFocusItem: s = -1,
      preventScroll: d = !0
    } = f, v = p(f, [
      "children",
      "maxHeight",
      "maxWidth",
      "minWidth",
      "innerRef",
      "autoFocus",
      "hideShimmer",
      "autoFocusItem",
      "preventScroll"
    ]);
    let u = fr(null), h = fr(), x = fr(s), [$, L] = Kt(!1), [E, M] = Kt(0), C = (m) => {
      var b, w, q, P;
      return (P = (q = (w = (b = h.current) == null ? void 0 : b.querySelector) == null ? void 0 : w.call(b, `[tabindex="${m}"]`)) == null ? void 0 : q.focus) == null ? void 0 : P.call(q, {
        preventScroll: d
      });
    }, I = (m) => {
      var b, w, q, P;
      if (E) {
        if (m.key === "ArrowUp") {
          m.preventDefault(), m.stopPropagation(), x.current = x.current <= 0 ? E - 1 : x.current - 1, C(x.current);
          return;
        }
        if (m.key === "ArrowDown") {
          m.preventDefault(), m.stopPropagation(), x.current = x.current < 0 || x.current === E - 1 ? 0 : x.current + 1, C(x.current);
          return;
        }
        if (m.key === "Enter" && ((w = (b = h.current) == null ? void 0 : b.contains) != null && w.call(b, document == null ? void 0 : document.activeElement))) {
          m.preventDefault(), m.stopPropagation(), (P = (q = document == null ? void 0 : document.activeElement) == null ? void 0 : q.click) == null || P.call(q);
          return;
        }
      }
    };
    return Me(() => {
      var m, b;
      h.current && M((b = (m = h.current.querySelectorAll("[tabindex]")) == null ? void 0 : m.length) != null ? b : 0);
    }, [h.current]), Me(() => {
      var m, b;
      u.current && L(!l && ((m = u.current) == null ? void 0 : m.scrollHeight) > ((b = u.current) == null ? void 0 : b.offsetHeight));
    }, [u.current]), Me(() => {
      var m, b;
      a && ((b = (m = h.current) == null ? void 0 : m.focus) == null || b.call(m, {
        preventScroll: d
      }));
    }, [a]), Me(() => {
      s >= 0 && h.current && C(s);
    }, [s]), /* @__PURE__ */ dr.createElement(
      ko,
      n({
        maxHeight: e,
        maxWidth: r,
        minWidth: t,
        hasShimmer: $,
        tabIndex: a ? 0 : -1,
        ref: (m) => {
          h.current = m, i && "current" in i && (i.current = m);
        },
        onKeyDown: I
      }, v),
      /* @__PURE__ */ dr.createElement(go, { ref: u }, o),
      !!$ && /* @__PURE__ */ dr.createElement(Ut, null)
    );
  }
);
Xt.displayName = "Menu";
var ur = Xt;

// src/components/OverflowMenu/OverflowMenu.styles.ts
import ys from "styled-components";
var Qt = ys.div`
  cursor: pointer;
  width: ${({ width: o }) => o};
`;

// src/components/OverflowMenu/OverflowMenu.tsx
var Yt = c(
  (C) => {
    var I = C, {
      children: o,
      disabled: e = !1,
      opener: r,
      openerWidth: t = "max-content",
      sameWidth: i = !1,
      closeOnSelect: a = !0,
      defaultOpen: l = !1,
      innerRef: s,
      menuProps: d = {},
      onClose: v,
      appendTo: g,
      placement: f = "bottom",
      tippyProps: u = {},
      ignoreOutsideClicksFrom: h = [],
      interceptOnOutsideClicks: x,
      maxHeight: $,
      maxWidth: L,
      minWidth: E
    } = I, M = p(I, [
      "children",
      "disabled",
      "opener",
      "openerWidth",
      "sameWidth",
      "closeOnSelect",
      "defaultOpen",
      "innerRef",
      "menuProps",
      "onClose",
      "appendTo",
      "placement",
      "tippyProps",
      "ignoreOutsideClicksFrom",
      "interceptOnOutsideClicks",
      "maxHeight",
      "maxWidth",
      "minWidth"
    ]);
    let [m, b] = Jt(l), w = (B, y) => {
      if (x) {
        x(b, y);
        return;
      }
      if (h != null && h.length && (y != null && y.target) && h.some((k) => {
        var F;
        return (F = k == null ? void 0 : k.current) == null ? void 0 : F.contains(y.target);
      }))
        return !1;
      b(!1), v == null || v();
    }, [q, P] = Jt(g);
    return ws(() => {
      P(g != null ? g : document.body);
    }, [g]), /* @__PURE__ */ gr.createElement(
      hs,
      T(n({}, u), {
        appendTo: q,
        interactive: !0,
        popperOptions: {
          modifiers: [
            { name: "arrow", enabled: !1 },
            {
              name: "preventOverflow",
              options: {
                altAxis: !0,
                tether: !1,
                padding: 0
              }
            },
            {
              name: "sameWidth",
              enabled: i,
              fn: ({ state: B }) => {
                B.styles.popper.width = `${B.rects.reference.width}px`;
              },
              phase: "beforeWrite",
              requires: ["computeStyles"]
            }
          ]
        },
        plugins: [
          {
            name: "hideOnEsc",
            defaultValue: !0,
            fn({ hide: B }) {
              function y(k) {
                k.key === "Escape" && (k.stopPropagation(), B());
              }
              return {
                onShow() {
                  document == null || document.addEventListener("keydown", y);
                },
                onHide() {
                  document == null || document.removeEventListener("keydown", y);
                }
              };
            }
          }
        ],
        visible: m,
        placement: f,
        onShow: () => b(!0),
        onHide: w,
        onClickOutside: w,
        render: (B) => m && /* @__PURE__ */ gr.createElement(
          ur,
          T(n(n({
            innerRef: s
          }, d), B), {
            maxHeight: $,
            maxWidth: L,
            minWidth: E
          }),
          $s.map(o, (y) => qs(y) ? y.props.tabIndex === void 0 || y.props.tabIndex < 0 ? y : vs(y, {
            onClick: typeof y.props.onClick == "function" && !y.props.disabled ? (...k) => {
              a && w(void 0, ...k), y.props.onClick(...k);
            } : void 0
          }) : null)
        )
      }),
      /* @__PURE__ */ gr.createElement(
        Qt,
        T(n({}, M), {
          width: t,
          onClick: e ? void 0 : (B) => {
            B.stopPropagation(), b((y) => !y);
          }
        }),
        r({
          isOpen: m,
          open: () => b(!0),
          close: w
        })
      )
    );
  }
);
Yt.displayName = "OverflowMenu";
var xo = Yt;

// src/components/MenuItem/MenuItem.styles.ts
import oi, { css as Zt } from "styled-components";
var ei = oi.div`
  & svg {
    color: ${({ theme: o }) => o.mosaiq.colors.passive};
  }

  ${({ disabled: o, selected: e, theme: r }) => o ? Zt`
          pointer-events: none;
        ` : Zt`
          cursor: pointer;

          &:focus {
            outline: none;

            ${_} {
              background-color: ${e ? r.mosaiq.colors.grey40 : r.mosaiq.colors.grey};
            }
          }
        `}
`, ri = oi.div`
  > div {
    width: 100%;
  }
`;

// src/components/MenuItem/MenuItem.tsx
var Ps = c(
  (L) => {
    var E = L, {
      autoFocus: o,
      tabIndex: e = -1,
      disabled: r = !1,
      avatar: t,
      active: i,
      primaryText: a,
      primaryTextProps: l,
      secondaryText: s,
      secondaryTextProps: d,
      primaryAction: v,
      secondaryAction: g,
      size: f,
      onClick: u,
      cascade: h,
      selected: x
    } = E, $ = p(E, [
      "autoFocus",
      "tabIndex",
      "disabled",
      "avatar",
      "active",
      "primaryText",
      "primaryTextProps",
      "secondaryText",
      "secondaryTextProps",
      "primaryAction",
      "secondaryAction",
      "size",
      "onClick",
      "cascade",
      "selected"
    ]);
    let M = xr(null), C = xr(), I = xr(null);
    return Cs(() => {
      var m, b;
      o && ((b = (m = M.current) == null ? void 0 : m.focus) == null || b.call(m, {
        preventScroll: !0
      }));
    }, [o]), /* @__PURE__ */ Do.createElement(
      ei,
      T(n({}, $), {
        selected: x,
        onClick: u ? (m) => {
          m.stopPropagation(), u(m);
        } : void 0,
        disabled: r,
        tabIndex: e,
        onMouseEnter: () => {
          var m, b;
          e >= 0 && ((b = (m = M.current) == null ? void 0 : m.focus) == null || b.call(m, {
            preventScroll: !0
          }));
        },
        ref: M
      }),
      h && (h == null ? void 0 : h.length) > 0 ? /* @__PURE__ */ Do.createElement(ri, null, /* @__PURE__ */ Do.createElement(
        xo,
        {
          appendTo: "parent",
          placement: "right-start",
          tippyProps: {
            offset: [-8, -20]
          },
          opener: ({ isOpen: m, open: b, close: w }) => (I.current = w, /* @__PURE__ */ Do.createElement(
            _,
            {
              "data-testid": "menuItemValue",
              disabled: r,
              avatar: t,
              primaryText: a,
              primaryTextProps: l,
              secondaryText: s,
              secondaryTextProps: d,
              primaryAction: /* @__PURE__ */ Do.createElement(Ts, null),
              secondaryAction: g,
              size: f,
              active: i,
              onMouseEnter: () => {
                clearTimeout(C.current), !m && b();
              },
              onMouseLeave: () => {
                C.current = setTimeout(() => {
                  w();
                }, 100);
              },
              onClick: u ? (q) => {
                q.stopPropagation(), u(q);
              } : void 0
            }
          ))
        },
        /* @__PURE__ */ Do.createElement(
          "div",
          {
            onMouseLeave: () => {
              var m;
              (m = I.current) == null || m.call(I);
            },
            onMouseEnter: () => {
              clearTimeout(C.current);
            }
          },
          Ss.map(h, (m) => ks(m, {
            onMouseEnter: () => {
              clearTimeout(C.current);
            }
          }))
        )
      )) : /* @__PURE__ */ Do.createElement(
        _,
        {
          "data-testid": "menuItemValue",
          disabled: r,
          avatar: t,
          primaryText: a,
          primaryTextProps: l,
          secondaryText: s,
          secondaryTextProps: d,
          primaryAction: v,
          secondaryAction: g,
          size: f,
          active: i,
          selected: x
        }
      )
    );
  }
), Fo = Ps;

// src/components/Autocomplete/Autocomplete.styles.ts
import Es from "styled-components";
var ti = Es.div`
  position: relative;

  [data-tippy-root] {
    width: 100%;
  }
`;

// src/components/utils/LazyTippy.tsx
import ii, { useEffect as Is } from "react";
import Ms from "@tippyjs/react/headless";
var Le = (o) => {
  let [e, r] = ii.useState(!1), t = {
    fn: () => ({
      onMount: () => r(!0),
      onHidden: () => r(!1)
    })
  }, i = n({}, o);
  if (i.plugins = [t, ...o.plugins || []], o.render) {
    let a = o.render;
    i.render = (...l) => e ? a(...l) : "";
  } else
    i.content = e ? o.content : "";
  return Is(() => {
    o.visible || r(!1);
  }, [o.visible]), /* @__PURE__ */ ii.createElement(Ms, n({}, i));
};

// src/components/Autocomplete/Autocomplete.tsx
var li = "autocomplete-items", Fs = c(
  (f) => {
    var u = f, {
      children: o,
      innerRef: e,
      inputProps: r,
      renderInput: t,
      closeOnSelect: i,
      appendTo: a = "parent",
      sameWidth: l = !1,
      onClose: s,
      lazyMounting: d = !1,
      maxHeight: v = 304
    } = u, g = p(u, [
      "children",
      "innerRef",
      "inputProps",
      "renderInput",
      "closeOnSelect",
      "appendTo",
      "sameWidth",
      "onClose",
      "lazyMounting",
      "maxHeight"
    ]);
    let [h, x] = si(!1), [$, L] = si(0), E = As(null), M = Ls.toArray(o), C = h && M.length > 0, I = d ? Le : Ds, m = 0, b = {
      role: "combobox",
      "aria-expanded": C,
      "aria-owns": li,
      "aria-haspopup": "listbox",
      inputProps: T(n({}, r), {
        "aria-autocomplete": "list"
      })
    }, w = () => {
      var y;
      return (y = E == null ? void 0 : E.current) == null ? void 0 : y.querySelector("[aria-selected=true]");
    }, q = () => {
      let y = w();
      y && y.scrollIntoView({
        behavior: "smooth",
        block: "nearest"
      });
    }, P = (y) => {
      switch (y.key) {
        case "Esc":
        case "Escape": {
          y.preventDefault(), C || (x(!1), s == null || s());
          break;
        }
        case "Enter": {
          let k = w();
          C && k && (y.preventDefault(), y.stopPropagation(), k.click());
          break;
        }
        case "Down":
        case "ArrowDown": {
          y.preventDefault(), y.stopPropagation();
          let k = $ < 0 || $ === m - 1 ? 0 : $ + 1;
          L(k);
          break;
        }
        case "Up":
        case "ArrowUp": {
          y.preventDefault(), y.stopPropagation();
          let k = $ <= 0 ? m - 1 : $ - 1;
          L(k);
          break;
        }
      }
    }, B = Bs(
      (y, k) => ni(y, {
        tabIndex: -1,
        role: "option",
        size: "small",
        active: k === $,
        "aria-selected": k === $,
        onMouseEnter: (F) => {
          var H, z;
          L(k), (z = (H = y.props) == null ? void 0 : H.onMouseEnter) == null || z.call(H, F);
        },
        onClick: (F) => {
          var H, z;
          (z = (H = y.props) == null ? void 0 : H.onClick) == null || z.call(H, F), i && (x(!1), s == null || s());
        }
      }),
      [$]
    );
    return ai(() => {
      q();
    }, [$]), ai(() => {
      L(0);
    }, [r == null ? void 0 : r.value]), /* @__PURE__ */ To.createElement(
      ti,
      {
        ref: e,
        onKeyDown: P,
        onFocus: () => x(!0)
      },
      /* @__PURE__ */ To.createElement(
        I,
        {
          appendTo: a,
          interactive: !0,
          visible: C,
          placement: "bottom-start",
          offset: [0, 8],
          maxWidth: "none",
          popperOptions: {
            modifiers: [
              { name: "arrow", enabled: !1 },
              {
                name: "sameWidth",
                enabled: l,
                fn: ({ state: y }) => {
                  y.styles.popper.width = `${y.rects.reference.width}px`;
                },
                phase: "beforeWrite",
                requires: ["computeStyles"]
              }
            ]
          },
          onClickOutside: () => {
            x(!1), s == null || s();
          },
          render: (y) => M.length > 0 ? /* @__PURE__ */ To.createElement(ko, n({ maxHeight: v, hasShimmer: !1, ref: E }, y), /* @__PURE__ */ To.createElement(
            go,
            {
              "data-testid": "autocompleteMenuCard",
              id: li,
              role: "listbox",
              onMouseLeave: () => L(-1)
            },
            M.map(
              (k) => br(k) && (k.type === _ || k.type === Fo) ? B(k, m++) : br(k) ? ni(k, {
                children: To.Children.toArray(
                  k.props.children
                ).map(
                  (F) => br(F) && F.type === _ ? B(F, m++) : F
                )
              }) : k
            )
          )) : void 0
        },
        /* @__PURE__ */ To.createElement("div", null, t ? t({ inputProps: b.inputProps }) : /* @__PURE__ */ To.createElement(pr, n(T(n({}, b), { endAdornment: /* @__PURE__ */ To.createElement(Q, { open: C }) }), g)))
      )
    );
  }
), Ws = Fs;

// src/components/Avatar/Avatar.tsx
import zs from "react";

// src/components/Avatar/Avatar.styles.ts
import Hs, { css as yr } from "styled-components";
import { rgba as Os } from "polished";
var Z = {
  nano: 1.5,
  micro: 2,
  small: 3,
  regular: 4,
  large: 5,
  xlarge: 15,
  xxlarge: 22.5
}, Be = Hs.div`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  line-height: 158%;
  border-radius: 50%;
  background-color: ${(o) => {
  var e;
  return (e = N(o, o.backgroundColor)) != null ? e : o.theme.mosaiq.colors.grey;
}};

  ${({ size: o = "regular", theme: e }) => yr`
    min-width: ${e.mosaiq.spacing(Z[o])}px;
    min-height: ${e.mosaiq.spacing(Z[o])}px;
    max-width: ${e.mosaiq.spacing(Z[o])}px;
    max-height: ${e.mosaiq.spacing(Z[o])}px;
  `};

  ${({ image: o }) => !!o && yr`
      background-origin: content-box;
      background-size: cover;
      background-position: top center;
      background-repeat: no-repeat;
      object-fit: cover;
      background-image: ${`url("${o}")`};
    `};

  ${({ overlay: o, theme: e }) => o && yr`
      & > * {
        z-index: 3;
      }

      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 50%;
        background-color: ${Os(e.mosaiq.colors.black, 0.4)};
        backdrop-filter: blur(2px);
        z-index: 1;
      }
    `};
`;

// src/components/Avatar/Avatar.tsx
var pi = c((t) => {
  var i = t, { children: o, innerRef: e } = i, r = p(i, ["children", "innerRef"]);
  return /* @__PURE__ */ zs.createElement(Be, n({ ref: e }, r), o);
});
pi.displayName = "Avatar";
var hr = pi;

// src/components/AvatarList/AvatarList.tsx
import Ae, { useMemo as js, cloneElement as Gs, Children as $r, Fragment as Rs } from "react";

// src/components/AvatarList/AvatarList.styles.ts
import Ns, { css as _s } from "styled-components";
var mi = Ns.div`
  display: flex;
  align-items: center;

  & > *:not(:first-of-type) {
    z-index: 2;
    margin-left: -${({ theme: o, size: e }) => o.mosaiq.spacing(e === "micro" || e === "nano" ? 0.5 : 1)}px;
  }

  ${Be} {
    border: 1px solid ${({ theme: o }) => o.mosaiq.colors.white};
    ${({ size: o = "regular", theme: e }) => _s`
      min-width: calc(${e.mosaiq.spacing(Z[o])}px + 1px);
      min-height: calc(${e.mosaiq.spacing(Z[o])}px + 1px);
      max-width: calc(${e.mosaiq.spacing(Z[o])}px + 1px);
      max-height: calc(${e.mosaiq.spacing(Z[o])}px + 1px);
    `};
  }
`;

// src/components/AvatarList/AvatarList.tsx
var ci = c(
  (a) => {
    var l = a, { children: o, size: e = "regular", maxCount: r, innerRef: t } = l, i = p(l, ["children", "size", "maxCount", "innerRef"]);
    if (!o)
      return null;
    let { displayChildren: s, overflowAvatar: d, overflowCount: v } = js(() => {
      let g, f = 0, u = $r.toArray(o);
      if (r) {
        let h = $r.count(o);
        h > 1 && r && (f = h > r ? h - (r - 1) : 0, f > 0 && (g = u[r - 1]), u = u.slice(
          0,
          r && h > r ? r - 1 : h
        ));
      }
      return {
        displayChildren: u,
        overflowAvatar: g,
        overflowCount: f
      };
    }, [o, r]);
    return /* @__PURE__ */ Ae.createElement(mi, n({ ref: t, size: e }, i), s.map((g, f) => /* @__PURE__ */ Ae.createElement(Rs, { key: f }, $r.map(
      g,
      (u) => Gs(u, {
        size: e
      })
    ))), v > 0 && !!(s != null && s.length) && /* @__PURE__ */ Ae.createElement(hr, T(n({}, (d == null ? void 0 : d.props) || {}), { size: e, overlay: !0 }), /* @__PURE__ */ Ae.createElement(D, n({ color: "white" }, pt(e)), "+", v)));
  }
);
ci.displayName = "AvatarList";
var Vs = ci;

// src/components/Badge/Badge.tsx
import Xs from "react";

// src/components/Badge/Badge.styles.ts
import Us, { css as se } from "styled-components";
var Ks = ({ theme: o, variant: e }) => {
  switch (e) {
    case "warning":
      return se`
        background-color: ${o.mosaiq.colors.sandyHeath};
        border-color: ${o.mosaiq.colors.navajoWhite};
        color: ${o.mosaiq.colors.sandyBrown};
      `;
    case "success":
      return se`
        background-color: ${o.mosaiq.colors.emeraldWhite};
        border-color: ${o.mosaiq.colors.mould};
        color: ${o.mosaiq.colors.emerald};
      `;
    case "error":
      return se`
        background-color: ${o.mosaiq.colors.apricotPeach};
        border-color: ${o.mosaiq.colors.coral};
        color: ${o.mosaiq.colors.coral};
      `;
    case "info":
      return se`
        background-color: ${o.mosaiq.colors.portage};
        border-color: ${o.mosaiq.colors.persianBlue};
        color: ${o.mosaiq.colors.persianBlue};
      `;
    default:
      return se`
        background-color: ${o.mosaiq.colors.grey};
        border-color: ${o.mosaiq.colors.grey60};
        color: ${o.mosaiq.colors.body};
      `;
  }
}, di = Us(fo).attrs({
  alignItems: "center",
  gap: 0.5
})`
  display: flex;
  border-radius: 1em;
  padding: ${({ theme: o }) => `${o.mosaiq.spacing(0.25)}px ${o.mosaiq.spacing(1)}px`};
  border: 1px solid;
  ${Ks}
  ${({ theme: o }) => o.mosaiq.typography.title7()}
`;

// src/components/Badge/Badge.tsx
var fi = c(
  (i) => {
    var a = i, { children: o, innerRef: e, variant: r } = a, t = p(a, ["children", "innerRef", "variant"]);
    return /* @__PURE__ */ Xs.createElement(di, n({ ref: e, variant: r }, t), o);
  }
);
fi.displayName = "Badge";
var Qs = fi;

// src/components/Button/Button.tsx
import xi from "react";

// src/components/Button/Button.styles.ts
import ui, { css as G } from "styled-components";
var Wo = {
  large: 1.25,
  regular: 1,
  small: 0.75
}, le = G`
  display: flex;
  align-items: center;
  border: 1px solid transparent;
  cursor: pointer;
  transition: 0.16s background-color linear;

  & > span:empty {
    display: none;
  }

  & > span {
    transition: 0.16s color linear;
  }

  & svg {
    flex-shrink: 0;
  }
`, pe = ({
  size: o,
  theme: e,
  variant: r
}) => {
  var t, i;
  return r === "outline" ? G`
      border-radius: ${e.mosaiq.spacing((t = Wo[o != null ? o : "regular"]) != null ? t : 1)}px;
      border: 1px solid ${e.mosaiq.colors.grey60};
    ` : G`
    border-radius: ${e.mosaiq.spacing((i = Wo[o != null ? o : "regular"]) != null ? i : 1)}px;
  `;
}, vr = ({
  variant: o = "primary",
  theme: e,
  disabled: r = !1,
  active: t = !1,
  selected: i = !1,
  error: a = !1
}) => a ? G`
      background-color: ${e.mosaiq.colors.softPeach};

      & > span {
        color: ${e.mosaiq.colors.error};
      }

      svg {
        color: ${e.mosaiq.colors.passive};
      }
    ` : o === "secondary" ? r ? G`
        background-color: unset;
        pointer-events: none;

        span,
        svg {
          color: ${e.mosaiq.colors.placeholder};
        }
      ` : i ? G`
        background-color: ${e.mosaiq.colors.grey20};
      ` : G`
      background-color: ${t ? e.mosaiq.colors.grey : "transparent"};

      & > span {
        color: ${e.mosaiq.colors.title};
      }

      svg {
        color: ${e.mosaiq.colors.passive};
      }

      &:hover {
        background-color: ${e.mosaiq.colors.grey20};
      }

      &:active {
        background-color: ${e.mosaiq.colors.grey60};
      }

      &:focus-visible {
        background-color: ${e.mosaiq.colors.grey};
      }
    ` : o === "outline" ? r ? G`
        background-color: unset;
        pointer-events: none;

        span,
        svg {
          color: ${e.mosaiq.colors.placeholder};
        }
      ` : G`
      background-color: ${e.colors.white};

      svg {
        color: ${e.mosaiq.colors.passive};
      }

      &:hover {
        background-color: ${e.mosaiq.colors.grey};
      }

      &:active {
        background-color: ${e.mosaiq.colors.grey20};
      }

      &:focus-visible {
        background-color: ${e.mosaiq.colors.grey20};
      }
    ` : r ? G`
      pointer-events: none;
      background-color: ${e.mosaiq.colors.grey20};

      & > span {
        color: ${e.mosaiq.colors.placeholder};
      }

      svg {
        color: ${e.mosaiq.colors.placeholder};
      }
    ` : i ? G`
      background-color: ${e.mosaiq.colors.black};

      & > span {
        color: ${e.mosaiq.colors.placeholder};
      }

      svg {
        color: ${e.mosaiq.colors.placeholder};
      }
    ` : G`
    background-color: ${e.mosaiq.colors.black};

    & > span {
      color: ${e.mosaiq.colors.white};
    }

    svg {
      color: ${e.mosaiq.colors.grey20};
    }

    &:hover {
      background-color: ${e.mosaiq.colors.body};

      & > span {
        color: ${e.mosaiq.colors.grey};
      }

      svg {
        color: ${e.mosaiq.colors.white};
      }
    }

    &:active {
      background-color: ${e.mosaiq.colors.black};

      & > span {
        color: ${e.mosaiq.colors.placeholder};
      }

      svg {
        color: ${e.mosaiq.colors.placeholder};
      }
    }

    &:focus-visible {
      background-color: ${e.mosaiq.colors.black};

      & > span {
        color: ${e.mosaiq.colors.placeholder};
      }

      svg {
        color: ${e.mosaiq.colors.placeholder};
      }
    }
  `, Js = ui.button`
  appearance: none;
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
`, gi = ui(Js)(({ variant: o }) => o === "ghost" ? null : G`
    width: max-content;

    ${le}

    ${vr}

  ${pe}

  ${({ size: e = "regular", theme: r }) => {
  switch (e) {
    case "large":
      return G`
            padding: 0px ${r.mosaiq.spacing(2)}px;
            min-height: ${r.mosaiq.spacing(5)}px;
            max-height: ${r.mosaiq.spacing(5)}px;
            ${r.mosaiq.typography.body2({ singleLine: !0 })}
          `;
    case "small":
      return G`
            padding: 0px ${r.mosaiq.spacing(1)}px;
            min-height: ${r.mosaiq.spacing(3)}px;
            max-height: ${r.mosaiq.spacing(3)}px;
            ${r.mosaiq.typography.body4({ singleLine: !0 })}
          `;
    default:
      return G`
            padding: 0px ${r.mosaiq.spacing(1.25)}px;
            min-height: ${r.mosaiq.spacing(4)}px;
            max-height: ${r.mosaiq.spacing(4)}px;
            ${r.mosaiq.typography.body3({ singleLine: !0 })}
          `;
  }
}}

  ${({ flex: e }) => e && G`
        width: 100%;
        justify-content: center;
      `};

    &&& span {
      ${({ ellipsize: e }) => e && G`
          display: initial;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        `};
    }

    & > span {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-family: ${({ theme: e }) => e.mosaiq.fonts.main};
      margin-left: ${({ startAdornment: e, theme: r, size: t }) => e ? r.mosaiq.spacing(t === "small" ? 0.5 : 0.75) : 0}px;
      margin-right: ${({ endAdornment: e, theme: r, size: t }) => e ? r.mosaiq.spacing(t === "small" ? 0.5 : 0.75) : 0}px;
      width: max-content;
    }
  `);

// src/components/Button/Button.tsx
var bi = c(
  (l) => {
    var s = l, { children: o, endAdornment: e, startAdornment: r, innerRef: t, href: i } = s, a = p(s, ["children", "endAdornment", "startAdornment", "innerRef", "href"]);
    let d = (i == null ? void 0 : i.startsWith("http")) || (i == null ? void 0 : i.startsWith("mailto")) || (i == null ? void 0 : i.startsWith("tel"));
    return /* @__PURE__ */ xi.createElement(
      gi,
      n(n({
        ref: t,
        startAdornment: r,
        endAdornment: e,
        as: i ? "a" : "button"
      }, {
        href: i,
        rel: i && d ? "noopener noreferrer" : void 0,
        type: i ? void 0 : "button"
      }), a),
      r,
      /* @__PURE__ */ xi.createElement("span", null, o),
      e
    );
  }
);
bi.displayName = "Button";
var O = bi;

// src/components/ButtonGroup/ButtonGroup.tsx
import Zs from "react";

// src/components/ButtonGroup/ButtonGroup.styles.ts
import Ys from "styled-components";
var yi = Ys.div`
  display: inline-flex;
  align-items: center;

  border-radius: 10px;
  gap: ${({ theme: o }) => o.mosaiq.spacing(0.5)}px;
  padding: ${({ theme: o }) => o.mosaiq.spacing(0.5)}px;
  background-color: ${(o) => {
  var e;
  return (e = N(o, o.backgroundColor)) != null ? e : o.theme.mosaiq.colors.grey;
}};

  & > button:not(:last-child) {
    margin-right: ${({ theme: o }) => o.mosaiq.spacing(0.5)}px;
  }
`;

// src/components/ButtonGroup/ButtonGroup.tsx
var hi = c(
  (t) => {
    var i = t, { children: o, innerRef: e } = i, r = p(i, ["children", "innerRef"]);
    return /* @__PURE__ */ Zs.createElement(yi, n({ ref: e }, r), o);
  }
);
hi.displayName = "ButtonGroup";
var ol = hi;

// src/components/Calendar/Calendar.tsx
import De from "react";
import tl from "react-calendar";
import { CaretLeft as il, CaretRight as nl } from "phosphor-react";
import { format as al } from "date-fns";

// src/components/Calendar/Calendar.styles.ts
import el, { css as rl } from "styled-components";
var $i = el.div`
  padding: ${({ theme: o }) => o.spacing(2)}px;
  max-width: ${({ theme: o, $maxWidth: e }) => o.spacing(e)}px;

  ${({ $popup: o }) => o && rl`
      margin-top: ${({ theme: e }) => e.spacing(1)}px;
      border-radius: ${({ theme: e }) => e.spacing(1.5)}px;
      background: ${({ theme: e }) => e.mosaiq.colors.white};
      z-index: 10;
      box-shadow: ${({ theme: e }) => e.mosaiq.elevation[2]};
    `}

  .react-calendar {
    padding: 0;

    .react-calendar__navigation__label {
      ${({ theme: o }) => o.mosaiq.typography.title6({ fontWeight: 500 })};
      color: ${({ theme: o }) => o.mosaiq.colors.passive};
      order: -1;
      text-align: left;
      padding-left: 0;
      background: transparent !important;
      border: 0;
      outline: none;
      cursor: pointer;

      &:hover,
      &:focus,
      &:active {
        background: transparent !important;
      }

      &:hover {
        color: ${({ theme: o }) => o.mosaiq.colors.body};
      }
    }

    .react-calendar__navigation__prev2-button,
    .react-calendar__navigation__next2-button {
      display: none !important;
    }

    .react-calendar__navigation__label__labelText {
      display: flex;
      align-items: center;
    }

    .react-calendar__navigation {
      display: flex;
      align-items: center;
      margin-bottom: ${({ theme: o }) => o.spacing(2)}px !important;
    }

    .react-calendar__navigation__arrow {
      background: transparent;
      min-width: ${({ theme: o }) => o.spacing(3)}px !important;
      min-height: ${({ theme: o }) => o.spacing(3)}px !important;
      width: ${({ theme: o }) => o.spacing(3)}px !important;
      height: ${({ theme: o }) => o.spacing(3)}px !important;
      border-radius: ${({ theme: o }) => o.spacing(1)}px !important;
      display: flex;
      justify-content: center;
      align-items: center;
      background: transparent;
      border: none;
      outline: none;
      cursor: pointer;
      padding: 0;

      svg {
        min-width: ${({ theme: o }) => o.spacing(2)}px !important;
        min-height: ${({ theme: o }) => o.spacing(2)}px !important;
        width: ${({ theme: o }) => o.spacing(2)}px !important;
        height: ${({ theme: o }) => o.spacing(2)}px !important;
        color: ${({ theme: o }) => o.mosaiq.colors.passive};
      }

      &:hover {
        background-color: ${({ theme: o }) => o.mosaiq.colors.grey};
      }
    }

    .react-calendar__tile {
      background: transparent;
      border: 0;
      margin: 0;
      outline: none;
      cursor: pointer;

      &:disabled {
        pointer-events: none;
        background-color: transparent !important;

        abbr {
          background-color: transparent !important;
          color: ${({ theme: o }) => o.mosaiq.colors.placeholder};
        }
      }
    }

    .react-calendar__year-view__months,
    .react-calendar__century-view__decades,
    .react-calendar__decade-view__years {
      .react-calendar__tile {
        min-height: ${({ theme: o }) => o.spacing(5)}px !important;
        border-radius: ${({ theme: o }) => o.spacing(1)}px;
        margin-bottom: ${({ theme: o }) => o.spacing(1)}px !important;
        ${({ theme: o }) => o.mosaiq.typography.title6({ fontWeight: 500 })};
        color: ${({ theme: o }) => o.mosaiq.colors.passive};

        abbr {
          ${({ theme: o }) => o.mosaiq.typography.title6({ fontWeight: 500 })};
          color: ${({ theme: o }) => o.mosaiq.colors.passive};
        }

        &--hasActive {
          color: ${({ theme: o }) => o.mosaiq.colors.black};

          abbr {
            color: ${({ theme: o }) => o.mosaiq.colors.black};
          }
        }

        &:hover {
          color: ${({ theme: o }) => o.mosaiq.colors.body};

          abbr {
            color: ${({ theme: o }) => o.mosaiq.colors.body};
          }
        }
      }
    }

    .react-calendar__month-view__weekdays {
      margin-bottom: ${({ theme: o }) => o.spacing(1)}px !important;
    }

    .react-calendar__month-view__weekdays__weekday {
      text-align: center;

      abbr {
        ${({ theme: o }) => o.mosaiq.typography.body3()};
        color: ${({ theme: o }) => o.mosaiq.colors.placeholder};
        text-decoration: none;
        font-style: italic;
      }
    }

    .react-calendar__month-view__days__day--neighboringMonth {
      abbr {
        color: ${({ theme: o }) => o.mosaiq.colors.placeholder};
      }
    }

    .react-calendar__month-view__days {
      .react-calendar__tile {
        margin-bottom: ${({ theme: o }) => o.spacing(1)}px !important;

        abbr {
          display: flex;
          align-items: center;
          justify-content: center;
          width: ${({ theme: o }) => o.spacing(4)}px !important;
          height: ${({ theme: o }) => o.spacing(4)}px !important;
          min-width: ${({ theme: o }) => o.spacing(4)}px !important;
          min-height: ${({ theme: o }) => o.spacing(4)}px !important;
          flex-basis: ${({ theme: o }) => o.spacing(4)}px !important;
          ${({ theme: o }) => o.mosaiq.typography.body3()};
          border-radius: ${({ theme: o }) => o.spacing(1)}px;
        }

        &:hover {
          abbr {
            background-color: ${({ theme: o }) => o.colors.grey};
          }
        }
      }

      .react-calendar__tile--now {
        abbr {
          color: ${({ theme: o }) => o.colors.white};
          background: ${({ theme: o }) => o.colors.black} !important;
          border-radius: ${({ theme: o }) => o.spacing(1)}px;
        }
      }

      .react-calendar__tile--active {
        abbr {
          background: ${({ theme: o }) => o.mosaiq.colors.grey20} !important;
        }

        &:hover,
        &:focus {
          abbr {
            background: ${({ theme: o }) => o.mosaiq.colors.grey40} !important;
          }
        }
      }
    }
  }
`;

// src/components/Calendar/Calendar.tsx
var sl = c(
  (i) => {
    var a = i, { calendarProps: o = {}, maxWidth: e = 40, popup: r = !1 } = a, t = p(a, ["calendarProps", "maxWidth", "popup"]);
    return /* @__PURE__ */ De.createElement($i, n({ $popup: r, $maxWidth: e }, t), /* @__PURE__ */ De.createElement(
      tl,
      T(n({}, o), {
        formatShortWeekday: (l, s) => al(s, "eeeee"),
        prevLabel: /* @__PURE__ */ De.createElement(il, { size: 20 }),
        nextLabel: /* @__PURE__ */ De.createElement(nl, { size: 20 })
      })
    ));
  }
), ll = sl;

// src/components/Card/Card.tsx
import ml from "react";

// src/components/Card/Card.styles.ts
import pl, { css as me } from "styled-components";
var vi = pl.div`
  border-radius: ${({ theme: o, borderRadius: e }) => o.mosaiq.spacing(e != null ? e : 1.5)}px;
  background-color: ${(o) => {
  var e;
  return (e = N(o, o.backgroundColor)) != null ? e : o.theme.mosaiq.colors.grey;
}};
  max-width: ${({ theme: o, maxWidth: e }) => typeof e == "number" ? `${o.mosaiq.spacing(e)}px` : typeof e == "string" ? e : void 0};
  min-width: ${({ theme: o, minWidth: e }) => typeof e == "number" ? `${o.mosaiq.spacing(e)}px` : typeof e == "string" ? e : void 0};
  transition:
    border-color 0.2s ease-in-out,
    background-color 0.2s ease-in-out;

  ${(o) => o.border && me`
      border: thin ${o.borderStyle || "solid"}
        ${o.borderColor ? N(o, o.borderColor) : o.theme.mosaiq.colors.grey60};
    `}

  ${(o) => (!!o.hoverBackgroundColor || !!o.hoverBorderColor) && me`
      &:hover {
        background-color: ${o.hoverBackgroundColor ? N(o, o.hoverBackgroundColor) : void 0};
        ${o.border && me`
          border: thin ${o.borderStyle || "solid"}
            ${o.hoverBorderColor ? N(o, o.hoverBorderColor) : void 0};
        `}
      }
    `}

  ${(o) => (!!o.activeBackgroundColor || !!o.activeBorderColor) && me`
      &:active {
        background-color: ${o.activeBackgroundColor ? N(o, o.activeBackgroundColor) : void 0};
        ${o.border && me`
          border: thin ${o.borderStyle || "solid"}
            ${o.activeBorderColor ? N(o, o.activeBorderColor) : void 0};
        `}
      }
    `}
`;

// src/components/Card/Card.tsx
var qi = c((t) => {
  var i = t, { children: o, innerRef: e } = i, r = p(i, ["children", "innerRef"]);
  return /* @__PURE__ */ ml.createElement(vi, n({ ref: e }, r), o);
});
qi.displayName = "Card";
var ce = qi;

// src/components/CardAction/CardAction.tsx
import ul from "react";

// src/components/CardAction/CardAction.styles.ts
import cl, { css as qr } from "styled-components";
var dl = qr`
  box-shadow: ${({ theme: o }) => o.mosaiq.elevation[1]};
  border: 1px solid ${({ theme: o }) => o.mosaiq.colors.grey60};

  &:hover {
    background-color: ${({ theme: o }) => o.mosaiq.colors.grey} !important;
  }

  &:active {
    background-color: ${({ theme: o }) => o.mosaiq.colors.grey40} !important;
    border-color: ${({ theme: o }) => o.mosaiq.colors.grey40};
  }
`, fl = qr`
  border: 1px dashed ${({ theme: o }) => o.mosaiq.colors.grey60};
`, wi = cl(ce).attrs(({ active: o, theme: e }) => ({
  borderRadius: 2,
  role: "button",
  backgroundColor: o ? e.mosaiq.colors.black : "transparent"
}))`
  box-sizing: border-box;

  ${({ active: o, disabled: e, onClick: r, theme: t }) => !o && !e ? r ? dl : qr`
            box-shadow: ${t.mosaiq.elevation[1]};
            border: 1px solid ${t.mosaiq.colors.grey60};
          ` : e ? fl : ""}
`;

// src/components/CardAction/CardAction.tsx
var Ci = c((r) => {
  var t = r, { children: o } = t, e = p(t, ["children"]);
  return /* @__PURE__ */ ul.createElement(wi, n({}, e), o);
});
Ci.displayName = "CardAction";
var gl = Ci;

// src/components/Checkbox/Checkbox.tsx
import Po, { useState as xl, useEffect as Pi, useRef as bl } from "react";
import { Check as yl, Minus as hl } from "phosphor-react";

// src/components/Checkbox/Checkbox.styles.ts
import Si, { css as Ho } from "styled-components";
var wr = ve, ki = Si(Co)`
  gap: ${({ theme: o }) => o.mosaiq.spacing(1)}px;

  ${({ theme: o }) => o.mosaiq.mediaQueries.screenSize({ max: "small" })`
    gap: ${({ theme: e }) => e.mosaiq.spacing(1.5)}px;
  `};

  ${wr} {
    ${({ checked: o, disabled: e, hasLabel: r, theme: t, indeterminate: i }) => e ? o || i ? Ho`
            background-color: ${t.mosaiq.colors.grey60};
            border: thin solid ${t.mosaiq.colors.grey60};

            svg {
              color: ${({ theme: a }) => a.mosaiq.colors.passive};
            }
          ` : Ho`
          background-color: ${t.mosaiq.colors.grey};
          border: thin solid ${t.mosaiq.colors.grey40};
        ` : o || i ? Ho`
          background-color: ${t.mosaiq.colors.black};
          border: thin solid ${t.mosaiq.colors.black};

          ${!r && Ho`
            &:hover {
              background-color: ${t.mosaiq.colors.passive};
              border: thin solid ${t.mosaiq.colors.passive};
            }
          `}
        ` : Ho`
        background-color: ${t.mosaiq.colors.white};
        border: thin solid ${t.mosaiq.colors.grey60};

        ${!r && Ho`
          &:hover {
            border: thin solid ${t.mosaiq.colors.passive};
          }
        `}
      `}
  }
`, Ti = Si.div`
  display: flex;
  width: 100%;
  align-items: center;
  column-gap: ${({ theme: o }) => o.mosaiq.spacing(1.5)}px;

  ${({ inline: o }) => !o && Ho`
      flex-wrap: wrap;
      flex-direction: column;
      align-items: flex-start;
    `};
`;

// src/components/Checkbox/Checkbox.tsx
var Ei = c(
  (h) => {
    var x = h, {
      disabled: o = !1,
      onChange: e,
      label: r,
      labelProps: t,
      helperText: i,
      checked: a = !1,
      innerRef: l,
      inputProps: s,
      indeterminate: d = !1,
      startAdornment: v,
      endAdornment: g,
      inline: f = !0
    } = x, u = p(x, [
      "disabled",
      "onChange",
      "label",
      "labelProps",
      "helperText",
      "checked",
      "innerRef",
      "inputProps",
      "indeterminate",
      "startAdornment",
      "endAdornment",
      "inline"
    ]);
    let $ = bl(null), [L, E] = xl(a), M = typeof e == "function" && typeof a != "undefined";
    return Pi(() => {
      E(a);
    }, [a]), Pi(() => {
      $.current && $.current.indeterminate !== d && ($.current.indeterminate = d);
    }, [d, $.current]), /* @__PURE__ */ Po.createElement(
      ki,
      n({
        hasLabel: !!r || !!i,
        checked: L,
        disabled: o,
        indeterminate: !L && d,
        startAdornment: !0
      }, u),
      /* @__PURE__ */ Po.createElement(
        "input",
        T(n({
          type: "checkbox",
          ref: l,
          disabled: o
        }, s), {
          onChange: (C) => {
            var I;
            M || E(C.target.checked), e == null || e(C), (I = s == null ? void 0 : s.onChange) == null || I.call(s, C);
          },
          checked: L
        })
      ),
      /* @__PURE__ */ Po.createElement(wr, { "data-testid": "checkboxInput" }, d && !L ? /* @__PURE__ */ Po.createElement(hl, { weight: "bold" }) : L && /* @__PURE__ */ Po.createElement(yl, { weight: "bold" })),
      !!v && v,
      (!!r || !!i) && /* @__PURE__ */ Po.createElement(Ti, { inline: f }, !!r && /* @__PURE__ */ Po.createElement(
        D,
        n({
          ellipsis: { lines: 1 },
          variant: "body2",
          color: "body",
          fontWeight: 500
        }, t),
        r
      ), i && typeof i == "string" ? /* @__PURE__ */ Po.createElement(D, { ellipsis: { lines: 1 }, variant: "body4", color: "passive", italic: !0 }, i) : i),
      !!g && g
    );
  }
);
Ei.displayName = "Checkbox";
var Fe = Ei;

// src/components/Container/Container.tsx
import * as Li from "react";

// src/components/Container/Container.styles.ts
import $l, { css as Ii } from "styled-components";
var Mi = $l.div`
  width: 100%;
  margin: 0 auto;

  ${({ position: o, top: e, bottom: r, left: t, right: i, theme: a }) => o && Ii`
      position: ${o};
      top: ${typeof e == "number" ? `${a.spacing(e)}px` : e};
      bottom: ${typeof r == "number" ? `${a.spacing(r)}px` : r};
      left: ${typeof t == "number" ? `${a.spacing(t)}px` : t};
      right: ${typeof i == "number" ? `${a.spacing(i)}px` : i};
    `}

  ${({ fullWidth: o, maxWidth: e, theme: r }) => !o && Ii`
      max-width: ${e || r.dimensions.maxContainerWidth}px;
    `}
`;

// src/components/Container/Container.tsx
var Bi = c(
  (v) => {
    var g = v, { position: o, top: e, bottom: r, left: t, right: i, fullWidth: a, maxWidth: l, children: s } = g, d = p(g, ["position", "top", "bottom", "left", "right", "fullWidth", "maxWidth", "children"]);
    return /* @__PURE__ */ Li.createElement(
      Mi,
      T(n({}, d), {
        position: o,
        top: e,
        bottom: r,
        left: t,
        right: i,
        fullWidth: a,
        maxWidth: l
      }),
      s
    );
  }
);
Bi.displayName = "Container";
var vl = Bi;

// src/components/Divider/Divider.tsx
import ql from "react";

// src/components/Divider/Divider.styles.ts
import Ai from "styled-components";
var Di = Ai.hr`
  width: 100%;
  margin-block: ${({ theme: o }) => o.spacing(2)}px;
  border: none;

  border-top: 1px solid
    ${({ $color: o, theme: e }) => o && e.mosaiq.colors[o] || e.mosaiq.colors.grey20};
`, Fi = Ai.div`
  width: 1px;
  background-color: ${({ $color: o, theme: e }) => o && e.mosaiq.colors[o] || e.mosaiq.colors.grey20};
  height: 100%;
`;

// src/components/Divider/Divider.tsx
var wl = c((t) => {
  var i = t, { color: o, vertical: e } = i, r = p(i, ["color", "vertical"]);
  return /* @__PURE__ */ ql.createElement(e ? Fi : Di, n({ $color: o }, r));
}), Cl = wl;

// src/components/Dropdown/Dropdown.tsx
import Jo from "react";
var Sl = (M) => {
  var C = M, {
    value: o,
    renderValue: e,
    options: r = [],
    renderOption: t,
    placeholder: i = "Select",
    startAdornment: a,
    endAdornment: l,
    disabled: s = !1,
    locked: d = !1,
    defaultOpen: v = !1,
    placement: g = "bottom-start",
    appendTo: f = "parent",
    variant: u = "secondary",
    onSelectItem: h,
    closeOnSelect: x = !0,
    menuProps: $,
    buttonEndAdornment: L
  } = C, E = p(C, [
    "value",
    "renderValue",
    "options",
    "renderOption",
    "placeholder",
    "startAdornment",
    "endAdornment",
    "disabled",
    "locked",
    "defaultOpen",
    "placement",
    "appendTo",
    "variant",
    "onSelectItem",
    "closeOnSelect",
    "menuProps",
    "buttonEndAdornment"
  ]);
  return /* @__PURE__ */ Jo.createElement(
    xo,
    {
      "data-testid": "dropDownOverflowMenu",
      appendTo: f,
      disabled: !!(s || d),
      placement: g,
      defaultOpen: v,
      closeOnSelect: x,
      menuProps: $,
      opener: ({ isOpen: m }) => /* @__PURE__ */ Jo.createElement(
        O,
        n({
          "data-testid": "dropDownBtn",
          active: !0,
          disabled: s,
          variant: u,
          startAdornment: a,
          endAdornment: L === void 0 ? /* @__PURE__ */ Jo.createElement(Q, { open: m, locked: d }) : L
        }, E),
        /* @__PURE__ */ Jo.createElement("span", null, o != null ? typeof o == "string" && !e ? o : e == null ? void 0 : e(o) : /* @__PURE__ */ Jo.createElement(Xo, null, i)),
        l
      )
    },
    r.map(
      (m, b) => typeof m == "string" && !t ? /* @__PURE__ */ Jo.createElement(
        Fo,
        {
          size: "small",
          key: typeof m == "string" ? m : b,
          tabIndex: b,
          primaryText: m,
          primaryTextProps: { fontWeight: 500 },
          onClick: () => h == null ? void 0 : h(m)
        }
      ) : t == null ? void 0 : t(m, b)
    )
  );
}, kl = c(Sl);

// src/components/Expander/Expander.tsx
import de, { useState as Tl } from "react";
import { CaretDown as Pl } from "phosphor-react";

// src/components/Expander/Expander.styles.ts
import He from "styled-components";
var Cr = He.div`
  overflow-y: hidden;
  max-height: 0;
  transition: max-height 400ms ease-in-out;
`, We = He.div`
  display: flex;
  align-items: center;
  gap: ${({ theme: o }) => o.spacing(1)}px;

  list-style: none;
  cursor: pointer;

  ${({ theme: o }) => o.mosaiq.typography.body3({ singleLine: !0 })};

  & > svg {
    opacity: 0.5;
    transition: transform 250ms ease;
    transform: rotate(0deg);
  }
`, Sr = He.span``, Wi = He.aside`
  &[open] ${We} {
    & ${Sr} {
      display: none;
    }

    &::before {
      content: 'Hide';
    }
  }

  &[open] ${Cr} {
    max-height: 100vh;
  }

  &[open] ${We} > svg {
    transform: rotate(-180deg);
  }
`;

// src/components/Expander/Expander.tsx
var El = c(
  (i) => {
    var a = i, { label: o = "Show", open: e = !1, children: r } = a, t = p(a, ["label", "open", "children"]);
    let [l, s] = Tl(e);
    return /* @__PURE__ */ de.createElement(Wi, n({ open: l }, t), /* @__PURE__ */ de.createElement(Cr, null, r), /* @__PURE__ */ de.createElement(We, { onClick: () => s((d) => !d), role: "button" }, /* @__PURE__ */ de.createElement(Sr, null, o), /* @__PURE__ */ de.createElement(Pl, null)));
  }
), Il = El;

// src/components/FloatingActionButton/FloatingActionButton.tsx
import Ll from "react";

// src/components/FloatingActionButton/FloatingActionButton.styles.ts
import Ml, { css as kr } from "styled-components";
var Hi = Ml.button`
  ${le}
  justify-content: center;
  min-width: ${({ theme: o }) => o.mosaiq.spacing(6)}px;
  min-height: ${({ theme: o }) => o.mosaiq.spacing(6)}px;
  max-width: ${({ theme: o }) => o.mosaiq.spacing(6)}px;
  max-height: ${({ theme: o }) => o.mosaiq.spacing(6)}px;
  border-radius: 50%;

  svg {
    min-width: ${({ theme: o }) => o.mosaiq.spacing(3)}px;
    min-height: ${({ theme: o }) => o.mosaiq.spacing(3)}px;
    max-width: ${({ theme: o }) => o.mosaiq.spacing(3)}px;
    max-height: ${({ theme: o }) => o.mosaiq.spacing(3)}px;
  }

  ${({ theme: o, disabled: e, active: r }) => e ? kr`
          pointer-events: none;
          background-color: ${o.mosaiq.colors.grey20};

          svg {
            color: ${o.mosaiq.colors.placeholder};
          }
        ` : r ? kr`
            background-color: ${o.mosaiq.colors.black};
            box-shadow:
              0px 0px 10px rgba(0, 0, 0, 0.05),
              0px 5px 10px rgba(0, 0, 0, 0.05),
              0px 2px 4px rgba(0, 0, 0, 0.05),
              0px 10px 20px rgba(0, 0, 0, 0.05);

            svg {
              color: ${o.mosaiq.colors.white};
            }
          ` : kr`
            background-color: ${o.mosaiq.colors.action};
            box-shadow:
              0px 5px 10px rgba(0, 87, 255, 0.1),
              0px 2px 4px rgba(0, 87, 255, 0.15);
            transition:
              0.2s opacity ease-in-out,
              0.2s background-color ease-in-out;

            svg {
              color: ${o.mosaiq.colors.white};
            }

            &:hover {
              opacity: 0.75;
            }

            &:active {
              opacity: 1;
              background-color: ${o.mosaiq.colors.black};
              box-shadow:
                0px 0px 10px rgba(0, 0, 0, 0.05),
                0px 5px 10px rgba(0, 0, 0, 0.05),
                0px 2px 4px rgba(0, 0, 0, 0.05),
                0px 10px 20px rgba(0, 0, 0, 0.05);
            }
          `}
`;

// src/components/FloatingActionButton/FloatingActionButton.tsx
var Oi = c(
  (t) => {
    var i = t, { children: o, innerRef: e } = i, r = p(i, ["children", "innerRef"]);
    return /* @__PURE__ */ Ll.createElement(Hi, n({ ref: e }, r), o);
  }
);
Oi.displayName = "Fab";
var Bl = Oi;

// src/components/Grid/Grid.tsx
import Fl from "react";

// src/components/Grid/Grid.styles.ts
import Al, { css as Dl } from "styled-components";
var zi = Al(tr)`
  display: grid;
  grid-gap: ${({ gap: o, theme: e }) => e.mosaiq.spacing(o)}px;
  grid-template-columns: ${({ $columns: o }) => typeof o == "string" ? o : `repeat(${o}, 1fr)`};
  grid-auto-columns: ${({ $autoColumns: o }) => o};
  grid-auto-flow: ${({ $autoFlow: o }) => o};
  align-items: ${({ $alignItems: o }) => o};
  grid-row: ${({ $gridRow: o }) => o};
  grid-column: ${({ $gridColumn: o }) => o};

  ${({ $innerBorder: o }) => o && Dl`
      border: 1px solid ${({ theme: e }) => e.mosaiq.colors.grey60};

      & > *:not(*:last-child) {
        border-right: 1px solid ${({ theme: e }) => e.mosaiq.colors.grey60};
      }
    `}
`;

// src/components/Grid/Grid.tsx
var Wl = c(
  (g) => {
    var f = g, {
      columns: o = "none",
      autoColumns: e = "auto",
      autoFlow: r = "row",
      alignItems: t,
      gridRow: i,
      gridColumn: a,
      innerBorder: l = !1,
      gap: s = 0,
      children: d
    } = f, v = p(f, [
      "columns",
      "autoColumns",
      "autoFlow",
      "alignItems",
      "gridRow",
      "gridColumn",
      "innerBorder",
      "gap",
      "children"
    ]);
    return /* @__PURE__ */ Fl.createElement(
      zi,
      n({
        $columns: o,
        $autoColumns: e,
        $autoFlow: r,
        $innerBorder: l,
        $alignItems: t,
        $gridRow: i,
        $gridColumn: a,
        gap: s
      }, v),
      d
    );
  }
), Hl = Wl;

// src/components/GridPopover/GridPopover.tsx
import Oo, {
  Children as Gi,
  cloneElement as Pr,
  isValidElement as fe,
  useCallback as Ri,
  useEffect as Vi,
  useRef as Ol,
  useState as Ui
} from "react";
import zl from "@tippyjs/react/headless";

// src/components/GridPopover/GridPopover.styles.ts
import Tr from "styled-components";
var Ni = Tr.div`
  cursor: pointer;
  width: max-content;
`, _i = Tr.div`
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
`, ji = Tr.div`
  display: grid;
  grid-template-columns: ${({ columns: o = 6 }) => `repeat(${o}, 1fr)`};
  gap: ${({ theme: o }) => o.spacing(0.5)}px;
`;

// src/components/GridPopover/GridPopover.tsx
var Nl = "grid-popover-items", Ki = c(
  (L) => {
    var E = L, {
      children: o,
      header: e,
      footer: r,
      innerRef: t,
      disabled: i = !1,
      opener: a,
      onOpen: l,
      onClose: s,
      maxWidth: d,
      maxHeight: v = 304,
      minWidth: g,
      appendTo: f = "parent",
      closeOnSelect: u = !0,
      defaultOpen: h = !1,
      columns: x = 6
    } = E, $ = p(E, [
      "children",
      "header",
      "footer",
      "innerRef",
      "disabled",
      "opener",
      "onOpen",
      "onClose",
      "maxWidth",
      "maxHeight",
      "minWidth",
      "appendTo",
      "closeOnSelect",
      "defaultOpen",
      "columns"
    ]);
    let [M, C] = Ui(h), [I, m] = Ui(0), b = Ol(null), w = Gi.toArray(o), q = 0, P = () => {
      l == null || l(), C(!0);
    }, B = () => {
      s == null || s(), C(!1);
    }, y = () => {
      var A;
      return (A = b == null ? void 0 : b.current) == null ? void 0 : A.querySelector("[aria-selected=true]");
    }, k = () => {
      let A = y();
      A && A.scrollIntoView({
        behavior: "smooth",
        block: "nearest"
      });
    }, F = (A) => {
      switch (A.key) {
        case "Esc":
        case "Escape": {
          A.preventDefault(), A.stopPropagation(), B();
          break;
        }
        case "Enter": {
          A.preventDefault(), A.stopPropagation();
          let S = y();
          M && S && S.click();
          break;
        }
        case "Down":
        case "ArrowDown": {
          A.preventDefault(), A.stopPropagation();
          let S = I < 0 || I === q - 1 ? 0 : I + 1;
          m(S);
          break;
        }
        case "Up":
        case "ArrowUp": {
          A.preventDefault(), A.stopPropagation();
          let S = I <= 0 ? q - 1 : I - 1;
          m(S);
          break;
        }
      }
    }, H = Ri(
      (A, S) => Pr(A, {
        tabIndex: 1,
        role: "option",
        active: S === I,
        "aria-selected": S === I,
        onMouseEnter: () => m(S),
        onClick: typeof A.props.onClick == "function" && !A.props.disabled ? (...W) => {
          A.props.onClick(...W), u && B();
        } : void 0
      }),
      [I, u]
    ), z = Ri(
      (A) => Pr(A, {
        onMouseEnter: () => m(-1),
        onClick: typeof A.props.onClick == "function" && !A.props.disabled ? (...S) => {
          A.props.onClick(...S), u && B();
        } : void 0
      }),
      [I, u]
    );
    return Vi(() => {
      k();
    }, [I]), Vi(() => {
      i && B();
    }, [i]), /* @__PURE__ */ Oo.createElement("div", { ref: t, onKeyDown: F }, /* @__PURE__ */ Oo.createElement(
      zl,
      {
        appendTo: f,
        interactive: !0,
        visible: M,
        placement: "bottom-start",
        offset: [0, 8],
        maxWidth: "none",
        popperOptions: {
          modifiers: [
            { name: "arrow", enabled: !1 },
            {
              name: "preventOverflow",
              options: {
                altAxis: !0,
                tether: !1
              }
            }
          ]
        },
        plugins: [
          {
            name: "hideOnEsc",
            defaultValue: !0,
            fn({ hide: A }) {
              function S(W) {
                W.key === "Escape" && (W.stopPropagation(), A());
              }
              return {
                onShow() {
                  document.addEventListener("keydown", S);
                },
                onHide() {
                  document.removeEventListener("keydown", S);
                }
              };
            }
          }
        ],
        onShow: () => C(!0),
        onHide: B,
        onClickOutside: B,
        render: (A) => /* @__PURE__ */ Oo.createElement(
          ko,
          n({
            maxWidth: d,
            maxHeight: v,
            minWidth: g,
            hasShimmer: !1,
            ref: b
          }, A),
          /* @__PURE__ */ Oo.createElement(
            go,
            {
              id: Nl,
              role: "listbox",
              onMouseLeave: () => m(-1),
              style: { position: "relative" }
            },
            e && /* @__PURE__ */ Oo.createElement(_i, null, e),
            /* @__PURE__ */ Oo.createElement(ji, { columns: x }, w.map(
              (S) => fe(S) && S.type === _ ? H(S, q++) : fe(S) ? Pr(S, {
                children: Gi.toArray(
                  S.props.children
                ).map(
                  (W) => fe(W) && W.type === _ ? H(W, q++) : fe(W) ? z(W) : W
                )
              }) : fe(S) ? z(S) : S
            )),
            r
          )
        )
      },
      /* @__PURE__ */ Oo.createElement(
        Ni,
        T(n({}, $), {
          onClick: i ? void 0 : (A) => {
            A.stopPropagation(), M ? u && B() : P();
          }
        }),
        a({
          isOpen: M,
          open: P,
          close: B
        })
      )
    ));
  }
);
Ki.displayName = "ListPopover";
var _l = Ki;

// src/components/IconAvatar/IconAvatar.tsx
import Er from "react";

// src/components/IconAvatar/IconAvatar.styles.ts
import jl, { css as Gl } from "styled-components";
var Xi = jl.div`
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ size: o, borderRadius: e, backgroundColor: r }) => Gl`
    min-width: ${o}px;
    max-width: ${o}px;
    min-height: ${o}px;
    max-height: ${o}px;
    border-radius: ${e}px;
    background-color: ${r};
  `}
`;

// src/components/IconAvatar/IconAvatar.tsx
var Rl = {
  nano: 1,
  micro: 1.5,
  small: 1.75,
  regular: 2,
  large: 2,
  xlarge: 7,
  xxlarge: 7
}, Vl = {
  nano: 0.25,
  micro: 0.5,
  small: 0.75,
  regular: 1,
  large: 1,
  xlarge: 2,
  xxlarge: 3
}, Qi = c(
  (l) => {
    var s = l, { size: o = "regular", color: e, children: r, weight: t = "regular", backgroundColor: i } = s, a = p(s, ["size", "color", "children", "weight", "backgroundColor"]);
    var d, v, g;
    return i ? /* @__PURE__ */ Er.createElement(
      Xi,
      {
        backgroundColor: (v = R.colors[i]) != null ? v : i,
        size: R.spacing(Z[o]),
        borderRadius: R.spacing(Vl[o])
      },
      Er.cloneElement(r, T(n({}, a), {
        size: R.spacing(Rl[o]),
        color: e ? (g = R.colors[e]) != null ? g : e : void 0,
        weight: t
      }))
    ) : Er.cloneElement(r, T(n({}, a), {
      size: R.spacing(Z[o]),
      color: e ? (d = R.colors[e]) != null ? d : e : void 0,
      weight: t
    }));
  }
);
Qi.displayName = "IconAvatar";
var Ul = Qi;

// src/components/IconBadge/IconBadge.tsx
import Kl, { css as Yo } from "styled-components";
var Xl = Kl.i`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  transition: 0.16s background-color linear;

  & svg {
    flex-shrink: 0;
  }

  ${({ theme: o, variant: e, error: r }) => r ? Yo`
        background-color: ${o.mosaiq.colors.softPeach};
        svg {
          color: ${o.mosaiq.colors.error};
        }
      ` : e === "secondary" ? Yo`
        background-color: 'transparent';
        svg {
          color: ${o.mosaiq.colors.passive};
        }
      ` : Yo`
      background-color: ${o.mosaiq.colors.black};
      svg {
        color: ${o.mosaiq.colors.grey20};
      }
    `}

  ${pe}

  ${({ size: o = "regular", theme: e }) => {
  switch (o) {
    case "large":
      return Yo`
          padding: 0px ${e.mosaiq.spacing(2)}px;
          min-height: ${e.mosaiq.spacing(5)}px;
          max-height: ${e.mosaiq.spacing(5)}px;
        `;
    case "small":
      return Yo`
          padding: 0px ${e.mosaiq.spacing(1)}px;
          min-height: ${e.mosaiq.spacing(3)}px;
          max-height: ${e.mosaiq.spacing(3)}px;
        `;
    default:
      return Yo`
          padding: 0px ${e.mosaiq.spacing(1.25)}px;
          min-height: ${e.mosaiq.spacing(4)}px;
          max-height: ${e.mosaiq.spacing(4)}px;
        `;
  }
}}
`, Ql = Xl;

// src/components/IconButton/IconButton.tsx
import Ar, { useState as rp, useEffect as tp } from "react";

// src/components/Tooltip/Tooltip.tsx
import Ir, { useMemo as Jl, useState as Mr, useEffect as Yl } from "react";
import Zl from "@tippyjs/react/headless";
import { followCursor as op } from "tippy.js";

// src/components/Tooltip/Tooltip.styles.ts
import Yi, { css as Oe } from "styled-components";
import { rgba as Ji } from "polished";
var Zi = Yi.div`
  display: inline-flex;
  max-width: ${({ flex: o }) => o ? "none" : "max-content"};
  flex: ${({ flex: o }) => o ? 1 : "none"};
`, on = Yi.div`
  display: inline-flex;
  max-width: ${({ theme: o, maxWidth: e }) => e && typeof e != "number" ? e : `${e || o.spacing(30)}px`};

  ${({ theme: o, size: e }) => e === "regular" ? Oe`
        padding: ${`${o.spacing(1)}px ${o.spacing(1.5)}px`};
        ${o.mosaiq.mixins.squircle({ borderRadius: o.spacing(1) })};
      ` : Oe`
      padding: ${`${o.spacing(0.5)}px ${o.spacing(1)}px`};
      ${o.mosaiq.mixins.squircle({ borderRadius: o.spacing(0.75) })};
      ${({ theme: r }) => r.mosaiq.typography.body3({ singleLine: !0 })}
    `}

  ${({ theme: o, variant: e }) => e === "light" ? Oe`
        background-color: ${Ji(o.mosaiq.colors.white, 0.96)};
        box-shadow:
          0px 0px 10px rgba(0, 0, 0, 0.05),
          0px 5px 10px rgba(0, 0, 0, 0.05),
          0px 2px 4px rgba(0, 0, 0, 0.05),
          0px 10px 20px rgba(0, 0, 0, 0.05);
      ` : Oe`
      background-color: ${Ji(o.mosaiq.colors.black, 0.9)};
      box-shadow:
        0px 0px 10px rgba(0, 0, 0, 0.05),
        0px 5px 10px rgba(0, 0, 0, 0.05),
        0px 2px 4px rgba(0, 0, 0, 0.05),
        0px 10px 20px rgba(0, 0, 0, 0.05);
      color: ${o.mosaiq.colors.white};
    `}
`;

// src/components/Tooltip/Tooltip.tsx
var en = c(
  (E) => {
    var M = E, {
      className: o,
      children: e,
      innerRef: r,
      disabled: t,
      variant: i = "dark",
      opener: a,
      trigger: l = "hover",
      placement: s = "bottom",
      followCursor: d = !1,
      size: v = "regular",
      maxWidth: g,
      delay: f,
      disableTouch: u = !0,
      triggerProps: h,
      lazyMounting: x = !1,
      onShow: $
    } = M, L = p(M, [
      "className",
      "children",
      "innerRef",
      "disabled",
      "variant",
      "opener",
      "trigger",
      "placement",
      "followCursor",
      "size",
      "maxWidth",
      "delay",
      "disableTouch",
      "triggerProps",
      "lazyMounting",
      "onShow"
    ]);
    let [C, I] = Mr(!1), [m, b] = Mr(!1), w = x ? Le : Zl, q = Jl(() => {
      let y = (k) => {
        t || m || I(k);
      };
      return l === "hover" && !m ? T(n({}, h), {
        onMouseEnter: () => {
          y(!0);
        },
        onMouseLeave: () => {
          y(!1);
        }
      }) : l === "click" ? T(n({}, h), {
        onClick: () => {
          y((k) => !k);
        }
      }) : h;
    }, [l, t]), [P, B] = Mr("parent");
    return Yl(() => {
      var y;
      B((y = document.body) != null ? y : "parent"), b(/iPhone|iPad|iPod/.test(navigator.platform));
    }, []), /* @__PURE__ */ Ir.createElement(
      w,
      {
        appendTo: P,
        interactive: !0,
        followCursor: d,
        plugins: [op],
        popperOptions: {
          modifiers: [
            { name: "arrow", enabled: !1 },
            ...v === "small" ? [
              {
                name: "offset",
                options: {
                  offset: [0, 4]
                }
              }
            ] : []
          ]
        },
        placement: s,
        onShow: () => {
          $ == null || $(), I(!0);
        },
        onHide: () => I(!1),
        onClickOutside: () => I(!1),
        visible: typeof f != "undefined" ? void 0 : C,
        delay: f,
        render: (y) => C && e && /* @__PURE__ */ Ir.createElement(
          on,
          n(n({
            maxWidth: g,
            ref: r,
            variant: i,
            size: v
          }, L), y),
          e
        ),
        triggerTarget: m ? null : void 0,
        touch: u
      },
      /* @__PURE__ */ Ir.createElement(Zi, n({ className: o }, q), a({
        isOpen: C
      }))
    );
  }
);
en.displayName = "Tooltip";
var ue = en;

// src/components/IconButton/IconButton.styles.ts
import ep, { css as Lr } from "styled-components";
var Br = ep.button`
  ${le}
  justify-content: center;

  ${vr}

  ${pe}

  ${({ size: o = "regular", theme: e }) => {
  switch (o) {
    case "large":
      return Lr`
          min-width: ${e.mosaiq.spacing(5)}px;
          min-height: ${e.mosaiq.spacing(5)}px;
          max-width: ${e.mosaiq.spacing(5)}px;
          max-height: ${e.mosaiq.spacing(5)}px;
        `;
    case "small":
      return Lr`
          min-width: ${e.mosaiq.spacing(3)}px;
          min-height: ${e.mosaiq.spacing(3)}px;
          max-width: ${e.mosaiq.spacing(3)}px;
          max-height: ${e.mosaiq.spacing(3)}px;
        `;
    default:
      return Lr`
          min-width: ${e.mosaiq.spacing(4)}px;
          min-height: ${e.mosaiq.spacing(4)}px;
          max-width: ${e.mosaiq.spacing(4)}px;
          max-height: ${e.mosaiq.spacing(4)}px;
        `;
  }
}}

  svg,
  img {
    min-width: ${({ theme: o }) => o.mosaiq.spacing(2)}px;
    min-height: ${({ theme: o }) => o.mosaiq.spacing(2)}px;
    max-width: ${({ theme: o }) => o.mosaiq.spacing(2)}px;
    max-height: ${({ theme: o }) => o.mosaiq.spacing(2)}px;
  }
`;

// src/components/IconButton/IconButton.tsx
var rn = c(
  (i) => {
    var a = i, { children: o, tooltip: e, innerRef: r } = a, t = p(a, ["children", "tooltip", "innerRef"]);
    let [l, s] = rp(!1);
    return tp(() => {
      s(/iPhone|iPad|iPod/.test(navigator.platform));
    }, []), l ? /* @__PURE__ */ Ar.createElement(Br, n({ ref: r, type: "button" }, t), o) : /* @__PURE__ */ Ar.createElement(
      ue,
      {
        opener: () => /* @__PURE__ */ Ar.createElement(Br, n({ ref: r, type: "button" }, t), o),
        size: "small"
      },
      e
    );
  }
);
rn.displayName = "IconButton";
var so = rn;

// src/components/InputPills/InputPills.tsx
import oo, { useState as cn, useRef as Dr, useLayoutEffect as ap } from "react";

// src/components/Pill/Pill.tsx
import Zo from "react";

// src/components/Pill/Pill.styles.ts
import tn, { css as ge } from "styled-components";
import { X as ip } from "phosphor-react";
var ze = tn(ip)`
  max-width: 0px;
  max-height: 0px;
  min-width: 0px;
  min-height: 0px;
  opacity: 0;
  visibility: hidden;
`, nn = tn.div`
  display: inline-flex;
  align-items: center;
  ${({ theme: o, wrap: e }) => !e && `height: ${o.spacing(2.5)}px;`}
  border-radius: ${({ theme: o }) => `${o.spacing(0.5)}px`};
  background-color: ${({ theme: o, background: e }) => e ? o.mosaiq.colors[e] : o.mosaiq.colors.white};
  color: ${({ theme: o, color: e }) => e ? o.mosaiq.colors[e] : o.mosaiq.colors.body};
  max-width: 100%;
  border: 1px solid transparent;

  ${({ hasAvatar: o, theme: e }) => ge`
    padding: ${e.spacing(0.5)}px ${e.spacing(0.75)}px ${e.spacing(0.5)}px
      ${e.spacing(o ? 0.5 : 1)}px;
  `}

  ${({ activeRemove: o, theme: e }) => o && ge`
      padding-right: ${e.spacing(0.5)}px;

      ${ze} {
        max-width: ${({ theme: r }) => r.spacing(1.5)}px;
        max-height: ${({ theme: r }) => r.spacing(1.5)}px;
        min-width: ${({ theme: r }) => r.spacing(1.5)}px;
        min-height: ${({ theme: r }) => r.spacing(1.5)}px;
        opacity: 1;
        visibility: visible;
        margin-left: ${e.spacing(0.5)}px;
        cursor: pointer;
      }
    `}

  ${({ onClick: o, hasRemove: e, theme: r }) => (o || e) && ge`
      &:hover {
        border: 1px solid ${r.mosaiq.colors.placeholder};

        ${e && ge`
          padding-right: ${r.spacing(0.5)}px;
        `}

        ${ze} {
          max-width: ${({ theme: t }) => t.spacing(1.5)}px;
          max-height: ${({ theme: t }) => t.spacing(1.5)}px;
          min-width: ${({ theme: t }) => t.spacing(1.5)}px;
          min-height: ${({ theme: t }) => t.spacing(1.5)}px;
          opacity: 1;
          visibility: visible;
          margin-left: ${r.spacing(0.5)}px;
          cursor: pointer;
        }
      }

      &:active {
        border: 1px solid ${r.mosaiq.colors.placeholder};
        background-color: ${r.mosaiq.colors.grey};
      }
    `}

    ${({ wrap: o }) => o && ge`
      > ${D} {
        line-height: 1.2;
      }
    `}
`;

// src/components/Pill/Pill.tsx
var an = c(
  (v) => {
    var g = v, {
      avatar: o,
      children: e,
      onRemove: r,
      activeRemove: t,
      wrap: i,
      color: a = "body",
      background: l = "grey",
      title: s
    } = g, d = p(g, [
      "avatar",
      "children",
      "onRemove",
      "activeRemove",
      "wrap",
      "color",
      "background",
      "title"
    ]);
    let f = /* @__PURE__ */ Zo.createElement(Zo.Fragment, null, o, /* @__PURE__ */ Zo.createElement(
      D,
      {
        fontWeight: 500,
        paddingLeft: o ? 0.5 : 0,
        variant: "body3",
        ellipsis: i ? void 0 : { lines: 1 }
      },
      e
    ), !!r && /* @__PURE__ */ Zo.createElement(
      ze,
      {
        onClick: (u) => {
          u.stopPropagation(), r(u);
        }
      }
    ));
    return /* @__PURE__ */ Zo.createElement(
      nn,
      T(n({}, d), {
        wrap: i,
        hasAvatar: !!o,
        activeRemove: t,
        hasRemove: !!r,
        color: a,
        background: l,
        as: !i && s ? ue : void 0,
        opener: () => f,
        size: "small",
        delay: [500, 0]
      }),
      !i && s ? /* @__PURE__ */ Zo.createElement(D, { variant: "body3" }, s) : f
    );
  }
);
an.displayName = "Pill";
var xe = an;

// src/components/InputPills/InputPills.styles.tsx
import sn, { css as np } from "styled-components";
var ln = 100, pn = sn(Lo)`
  ${({ autoSize: o }) => !o && np`
      position: relative;
      overflow: hidden;
      justify-content: flex-start;

      input {
        min-width: 0;
      }
    `}
`, mn = sn(Lo)`
  position: absolute;
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  left: 0;
  right: 0;
  overflow: hidden;
`;

// src/components/InputPills/InputPills.tsx
var dn = ($) => {
  var L = $, {
    innerRef: o,
    label: e,
    helperText: r,
    autoSize: t = !0,
    autoFocus: i = !1,
    disabled: a = !1,
    error: l = !1,
    required: s = !1,
    startAdornment: d,
    endAdornment: v,
    inputProps: g = {},
    items: f = [],
    renderPill: u,
    renderOverflowPill: h
  } = L, x = p(L, [
    "innerRef",
    "label",
    "helperText",
    "autoSize",
    "autoFocus",
    "disabled",
    "error",
    "required",
    "startAdornment",
    "endAdornment",
    "inputProps",
    "items",
    "renderPill",
    "renderOverflowPill"
  ]);
  let { current: E } = Dr(wo(e)), M = Dr(null), C = Dr(null), [I, m] = cn(i), [b, w] = cn([]);
  return ap(() => {
    if (t || !C.current || !M.current) return;
    let q = Array.from(C.current.children), P = [], B = C.current.offsetWidth;
    for (let y = q.length - 1; y > 0; y--) {
      let k = q[y];
      if (k.offsetLeft + k.offsetWidth > B - ln - 40)
        P.push(f[y]);
      else
        break;
    }
    P.length ? w(P) : (w([]), M.current.style.width = "");
  }, [f, t]), /* @__PURE__ */ oo.createElement(Qo, n({ ref: o }, x), !!e && /* @__PURE__ */ oo.createElement("label", { htmlFor: E }, /* @__PURE__ */ oo.createElement(uo, { color: a ? "placeholder" : "body" }, e, s && /* @__PURE__ */ oo.createElement(oo.Fragment, null, "*"))), /* @__PURE__ */ oo.createElement(
    pn,
    {
      readOnly: g == null ? void 0 : g.readOnly,
      disabled: a,
      error: l,
      focus: I,
      autoSize: t,
      onClick: (q) => {
        var P;
        return (P = q.target.querySelector("input")) == null ? void 0 : P.focus();
      }
    },
    d,
    !t && /* @__PURE__ */ oo.createElement(mn, { ref: C, "aria-hidden": !0 }, f.map((q, P) => /* @__PURE__ */ oo.createElement(xe, n({ key: P }, u(q, P))))),
    f.filter((q) => !b.includes(q)).map((q, P) => /* @__PURE__ */ oo.createElement(xe, n({ key: P }, u(q, P)))),
    !!b.length && !t && h && /* @__PURE__ */ oo.createElement(xe, n({}, h(b))),
    /* @__PURE__ */ oo.createElement(
      "input",
      T(n({}, g), {
        id: e ? E : void 0,
        disabled: a,
        autoFocus: i,
        onFocus: (q) => {
          var P;
          m(!0), (P = g == null ? void 0 : g.onFocus) == null || P.call(g, q);
        },
        onBlur: (q) => {
          var P;
          m(!1), (P = g == null ? void 0 : g.onBlur) == null || P.call(g, q);
        },
        ref: M
      })
    ),
    v
  ), !!r && /* @__PURE__ */ oo.createElement(D, { variant: "body4", color: l ? "error" : a ? "placeholder" : "passive" }, r));
};
dn.displayName = "InputPills";
var sp = c(dn);

// src/components/ListGroup/ListGroup.tsx
import Ne, { useState as un } from "react";

// src/components/ListGroup/ListGroup.styles.ts
import lp from "styled-components";
var fn = lp.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme: o }) => o.spacing(0.5)}px;
  overflow: hidden;
  transition: max-height 0.4s ease-in-out;
  max-height: ${({ isOpen: o }) => o ? 1e5 : 0}px;
`;

// src/components/ListGroup/ListGroup.tsx
var gn = c(
  (l) => {
    var s = l, { label: o, labelProps: e, open: r = !0, collapsible: t = !0, children: i } = s, a = p(s, ["label", "labelProps", "open", "collapsible", "children"]);
    let [d, v] = un(r), [g] = un(wo(o));
    return /* @__PURE__ */ Ne.createElement("div", n({ role: "group", "aria-labelledby": g }, a), !!o && /* @__PURE__ */ Ne.createElement(
      _,
      n({
        size: "regular",
        primaryText: o,
        primaryTextProps: {
          textTransform: "uppercase",
          variant: "title7",
          color: "passive"
        },
        secondaryAction: t ? /* @__PURE__ */ Ne.createElement(Q, { heading: !0, open: d }) : void 0,
        onClick: t ? () => v(!d) : void 0,
        id: g
      }, e)
    ), /* @__PURE__ */ Ne.createElement(fn, { isOpen: d, "aria-expanded": d }, i));
  }
);
gn.displayName = "ListGroup";
var pp = gn;

// src/components/ListPopover/ListPopover.tsx
import zo, {
  Children as hn,
  cloneElement as Wr,
  isValidElement as _e,
  useCallback as $n,
  useEffect as Hr,
  useRef as mp,
  useState as vn
} from "react";
import cp from "@tippyjs/react/headless";

// src/components/ListPopover/ListPopover.styles.ts
import Fr from "styled-components";
var xn = Fr.div`
  cursor: pointer;
  width: max-content;
`, bn = Fr.div`
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
`, yn = Fr.div`
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
`;

// src/components/ListPopover/ListPopover.tsx
var dp = "list-popover-items", qn = c(
  (E) => {
    var M = E, {
      children: o,
      header: e,
      footer: r,
      innerRef: t,
      disabled: i = !1,
      opener: a,
      onOpen: l,
      onClose: s,
      maxWidth: d,
      maxHeight: v = 304,
      minWidth: g,
      sameWidth: f = !1,
      offset: u,
      appendTo: h = "parent",
      closeOnSelect: x = !0,
      defaultOpen: $ = !1
    } = M, L = p(M, [
      "children",
      "header",
      "footer",
      "innerRef",
      "disabled",
      "opener",
      "onOpen",
      "onClose",
      "maxWidth",
      "maxHeight",
      "minWidth",
      "sameWidth",
      "offset",
      "appendTo",
      "closeOnSelect",
      "defaultOpen"
    ]);
    let [C, I] = vn($), [m, b] = vn(0), w = mp(null), q = hn.toArray(o), P = 0, B = () => {
      l == null || l(), I(!0);
    }, y = () => {
      s == null || s(), I(!1);
    }, k = () => {
      var S;
      return (S = w == null ? void 0 : w.current) == null ? void 0 : S.querySelector("[aria-selected=true]");
    }, F = () => {
      let S = k();
      S && S.scrollIntoView({
        behavior: "smooth",
        block: "nearest"
      });
    }, H = (S) => {
      switch (S.key) {
        case "Esc":
        case "Escape": {
          S.preventDefault(), S.stopPropagation(), y();
          break;
        }
        case "Enter": {
          S.preventDefault(), S.stopPropagation();
          let W = k();
          C && W && W.click();
          break;
        }
        case "Down":
        case "ArrowDown": {
          S.preventDefault(), S.stopPropagation();
          let W = m < 0 || m === P - 1 ? 0 : m + 1;
          b(W);
          break;
        }
        case "Up":
        case "ArrowUp": {
          S.preventDefault(), S.stopPropagation();
          let W = m <= 0 ? P - 1 : m - 1;
          b(W);
          break;
        }
      }
    }, z = $n(
      (S, W) => Wr(S, {
        tabIndex: -1,
        role: "option",
        active: W === m,
        "aria-selected": W === m,
        onMouseEnter: () => b(W),
        onClick: (yo) => {
          var Io, jo;
          (jo = (Io = S.props) == null ? void 0 : Io.onClick) == null || jo.call(Io, yo), x && y();
        }
      }),
      [m]
    ), A = $n(
      (S) => Wr(S, {
        onMouseEnter: () => b(-1)
      }),
      [m]
    );
    return Hr(() => {
      F();
    }, [m]), Hr(() => {
      i && y();
    }, [i]), Hr(() => {
      $ && (l == null || l());
    }, []), /* @__PURE__ */ zo.createElement("div", { ref: t, onKeyDown: H }, /* @__PURE__ */ zo.createElement(
      cp,
      {
        appendTo: h,
        interactive: !0,
        visible: C,
        placement: "bottom-start",
        offset: u != null ? u : [0, 8],
        maxWidth: "none",
        popperOptions: {
          modifiers: [
            { name: "arrow", enabled: !1 },
            {
              name: "sameWidth",
              enabled: f,
              fn: ({ state: S }) => {
                S.styles.popper.width = `${S.rects.reference.width}px`;
              },
              phase: "beforeWrite",
              requires: ["computeStyles"]
            }
          ]
        },
        onClickOutside: y,
        render: (S) => e || q.length > 0 ? /* @__PURE__ */ zo.createElement(
          ko,
          n({
            maxWidth: d,
            maxHeight: v,
            minWidth: g,
            hasShimmer: !1,
            ref: w
          }, S),
          /* @__PURE__ */ zo.createElement(go, { id: dp, role: "listbox", onMouseLeave: () => b(-1) }, e && /* @__PURE__ */ zo.createElement(bn, null, e), q.map(
            (W) => _e(W) && W.type === _ ? z(W, P++) : _e(W) ? Wr(W, {
              children: hn.toArray(
                W.props.children
              ).map(
                (yo) => _e(yo) && yo.type === _ ? z(yo, P++) : yo
              )
            }) : _e(W) ? A(W) : W
          ), r && /* @__PURE__ */ zo.createElement(yn, null, r))
        ) : void 0
      },
      /* @__PURE__ */ zo.createElement(
        xn,
        T(n({}, L), {
          onClick: i ? void 0 : (S) => {
            S.stopPropagation(), C ? x && y() : B();
          }
        }),
        a({
          isOpen: C,
          open: B,
          close: y
        })
      )
    ));
  }
);
qn.displayName = "ListPopover";
var Or = qn;

// src/components/LogarithmicProgressBar/LogarithmicProgressBar.tsx
import up, { useState as gp, useEffect as xp, useRef as bp } from "react";

// src/components/ProgressBar/ProgressBar.tsx
import kn from "react";

// src/components/ProgressBar/utils.ts
var wn = ({ initial: o, value: e, total: r }) => Math.round(o ? (e - o) * 100 / (r - o) : e * 100 / r);

// src/components/ProgressBar/ProgressBar.styles.ts
import Cn from "styled-components";
var zr = Cn.div`
  height: ${({ theme: o }) => o.spacing(1)}px;
  border-radius: ${({ theme: o }) => o.spacing(1.5)}px;
  width: ${({ progress: o, theme: e }) => o > 0 ? `clamp(0%,${o}%,100%)` : `${e.spacing(1)}px`};
  transition: 0.2s width linear;
`, Sn = Cn.div`
  height: ${({ theme: o }) => o.spacing(1)}px;
  border-radius: ${({ theme: o }) => o.spacing(1.5)}px;
  background-color: ${({ theme: o }) => o.mosaiq.colors.grey20};

  ${zr} {
    background-color: ${(o) => {
  var e;
  return (e = N(o, o.backgroundColor)) != null ? e : o.theme.mosaiq.colors.black;
}};
  }
`;

// src/components/ProgressBar/ProgressBar.tsx
var fp = c(
  (a) => {
    var l = a, { value: o, total: e, initial: r = 0, innerRef: t } = l, i = p(l, ["value", "total", "initial", "innerRef"]);
    return /* @__PURE__ */ kn.createElement(
      Sn,
      n({
        role: "progressbar",
        "aria-valuenow": o,
        "aria-valuemax": e,
        "aria-valuemin": r,
        ref: t
      }, i),
      /* @__PURE__ */ kn.createElement(
        zr,
        {
          progress: wn({
            initial: r,
            total: e,
            value: o
          })
        }
      )
    );
  }
), Nr = fp;

// src/components/LogarithmicProgressBar/LogarithmicProgressBar.tsx
var yp = (a) => {
  var l = a, {
    speed: o = "normal",
    totalSteps: e = 3,
    currentStep: r = 1,
    isComplete: t
  } = l, i = p(l, [
    "speed",
    "totalSteps",
    "currentStep",
    "isComplete"
  ]);
  let [s, d] = gp(0), v = bp(r);
  return xp(() => {
    let f = 100 / e * r;
    v.current !== r && (v.current = r);
    let u, h = performance.now(), x = s, $ = (L) => {
      let C = 1 - 1 / (1 + (L - h) / (5e3 * (o === "fast" ? 1 : o === "normal" ? 4 : 10))), I = C * (2 - C), m = x + I * (f - x);
      d(m), m < f && (u = requestAnimationFrame($));
    };
    return u = requestAnimationFrame($), () => {
      u && cancelAnimationFrame(u);
    };
  }, [r, e]), /* @__PURE__ */ up.createElement(Nr, T(n({}, i), { value: t ? 100 : s, total: 100 }));
}, hp = yp;

// src/components/Radio/Radio.tsx
import ee, { useState as $p, useEffect as vp } from "react";

// src/components/Radio/Radio.styles.ts
import _r, { css as oe } from "styled-components";
var Tn = _r.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-radius: 50%;
`, jr = _r(ve)`
  border-radius: ${({ theme: o }) => o.spacing(50)}%;
`, Pn = _r(Co)`
  ${jr} {
    ${({ checked: o, disabled: e, hasLabel: r, theme: t }) => e ? o ? oe`
            background-color: ${t.mosaiq.colors.grey60};
            border: ${t.spacing(0.5)}px solid ${t.mosaiq.colors.grey};

            svg {
              color: ${({ theme: i }) => i.mosaiq.colors.passive};
            }
          ` : oe`
          background-color: ${t.mosaiq.colors.grey};
          border: thin solid ${t.mosaiq.colors.grey40};
        ` : o ? oe`
          border: ${t.spacing(0.5)}px solid ${t.mosaiq.colors.black};

          ${!r && oe`
            &:hover {
              background-color: ${t.mosaiq.colors.white};
              border: ${t.spacing(0.5)}px solid ${t.mosaiq.colors.passive};
            }
          `}
        ` : oe`
        background-color: ${t.mosaiq.colors.white};
        border: thin solid ${t.mosaiq.colors.grey60};

        ${!r && oe`
          &:hover {
            border: thin solid ${t.mosaiq.colors.passive};
          }
        `}
      `}
  }
`;

// src/components/Radio/Radio.tsx
var En = c(
  (v) => {
    var g = v, {
      disabled: o = !1,
      onChange: e,
      label: r,
      labelProps: t,
      helperText: i,
      checked: a = !1,
      innerRef: l,
      inputProps: s
    } = g, d = p(g, [
      "disabled",
      "onChange",
      "label",
      "labelProps",
      "helperText",
      "checked",
      "innerRef",
      "inputProps"
    ]);
    let f = typeof e == "function" && typeof a != "undefined", [u, h] = $p(a);
    return vp(() => {
      h(a);
    }, [a]), /* @__PURE__ */ ee.createElement(
      Pn,
      n({
        hasLabel: !!r || !!i,
        checked: u,
        disabled: o,
        ref: l
      }, d),
      /* @__PURE__ */ ee.createElement(
        "input",
        T(n({
          type: "radio",
          disabled: o
        }, s), {
          onChange: (x) => {
            var $;
            f || h(x.target.checked), e == null || e(x), ($ = s == null ? void 0 : s.onChange) == null || $.call(s, x);
          },
          checked: u
        })
      ),
      /* @__PURE__ */ ee.createElement(jr, null, u && /* @__PURE__ */ ee.createElement(Tn, null)),
      !!r && /* @__PURE__ */ ee.createElement(
        D,
        n({
          ellipsis: { lines: 1 },
          marginLeft: 1.5,
          variant: "body2",
          color: o ? "placeholder" : "body",
          fontWeight: 500
        }, t),
        r
      ),
      !!i && /* @__PURE__ */ ee.createElement(
        D,
        {
          ellipsis: { lines: 1 },
          marginLeft: 1.5,
          variant: "body4",
          color: o ? "placeholder" : "passive",
          italic: !0
        },
        i
      )
    );
  }
);
En.displayName = "Radio";
var qp = En;

// src/components/RadioButton/RadioButton.tsx
import Gr from "react";

// src/components/RadioButton/RadioButton.styles.ts
import wp from "styled-components";
var In = wp(Co)`
  input:checked + ${O} {
    background-color: ${({ theme: o }) => o.mosaiq.colors.grey};
    border-color: ${({ theme: o }) => o.mosaiq.colors.black};
  }
`;

// src/components/RadioButton/RadioButton.tsx
var Mn = c(
  (v) => {
    var g = v, {
      disabled: o = !1,
      onChange: e,
      label: r,
      labelProps: t,
      innerRef: i,
      inputProps: a,
      checked: l,
      id: s
    } = g, d = p(g, [
      "disabled",
      "onChange",
      "label",
      "labelProps",
      "innerRef",
      "inputProps",
      "checked",
      "id"
    ]);
    return /* @__PURE__ */ Gr.createElement(In, n({ hasLabel: !1, ref: i, htmlFor: s }, d), /* @__PURE__ */ Gr.createElement(
      "input",
      n({
        type: "radio",
        disabled: o,
        id: s != null ? s : r,
        onChange: e,
        defaultChecked: l
      }, a)
    ), /* @__PURE__ */ Gr.createElement(O, n({ variant: "outline", forwardedAs: "span" }, t), r));
  }
);
Mn.displayName = "RadioButton";
var be = Mn;

// src/components/RadioButton/RadioButtonGroup.tsx
import Cp from "styled-components";
var Sp = Cp(fo)`
  ${O} {
    border-radius: 0;
    border-color: ${({ theme: o }) => o.colors.grey60} !important;
  }

  ${be}:first-child {
    ${O} {
      border-radius: ${({ theme: o }) => o.spacing(1)}px 0 0 ${({ theme: o }) => o.spacing(1)}px;
    }
  }

  ${be}:last-child {
    ${O} {
      border-radius: 0 ${({ theme: o }) => o.spacing(1)}px ${({ theme: o }) => o.spacing(1)}px 0;
    }
  }

  ${be}:not(:last-child) {
    ${O} {
      border-right: none;
    }
  }

  input:checked + ${O} {
    background-color: ${(o) => N(o, o.activeColor, "colors")};

    svg {
      color: ${({ theme: o }) => o.colors.title};
    }
  }

  input:not(:checked) + ${O} {
    color: ${({ theme: o }) => o.colors.passive};
  }
`, kp = Sp;

// src/components/SegmentedButton/SegmentedButton.tsx
import je from "react";

// src/components/SegmentedButton/SegmentedButton.styles.ts
import Tp from "styled-components";
var Ln = Tp.div`
  display: inline-flex;
  gap: 2px;

  & > *:first-child ${O}, & > ${O}:first-child {
    ${({ theme: o, size: e }) => {
  var r;
  return o.mosaiq.mixins.squircle({
    corners: ["top-left", "bottom-left"],
    borderRadius: o.mosaiq.spacing((r = Wo[e != null ? e : "regular"]) != null ? r : 1)
  });
}};
  }

  &
    > *:not(:first-child):not(:last-child)
    ${O},
    &
    > ${O}:not(:first-child):not(:last-child),
  &
    > *:not(:first-child):not(:last-child)
    ${so},
    &
    > ${so}:not(:first-child):not(:last-child) {
    ${({ theme: o, size: e }) => {
  var r;
  return o.mosaiq.mixins.squircle({
    corners: [],
    borderRadius: o.mosaiq.spacing((r = Wo[e != null ? e : "regular"]) != null ? r : 1)
  });
}};
  }

  &
    > *:last-child
    ${O},
    &
    > *:last-child
    ${so},
    &
    > ${O}:last-child,
    &
    > ${so}:last-child {
    ${({ theme: o, size: e }) => {
  var r;
  return o.mosaiq.mixins.squircle({
    corners: ["top-right", "bottom-right"],
    borderRadius: o.mosaiq.spacing((r = Wo[e != null ? e : "regular"]) != null ? r : 1)
  });
}};
  }

  &
    > *:only-child
    ${O},
    &
    > *:only-child
    ${so},
    &
    > ${O}:only-child,
    &
    > ${so}:only-child {
    ${({ theme: o, size: e }) => {
  var r;
  return o.mosaiq.mixins.squircle({
    corners: ["top-right", "bottom-right", "top-left", "bottom-left"],
    borderRadius: o.mosaiq.spacing((r = Wo[e != null ? e : "regular"]) != null ? r : 1)
  });
}};
  }
`;

// src/components/SegmentedButton/SegmentedButton.tsx
var Pp = (l) => {
  var s = l, {
    size: o,
    variant: e,
    selected: r,
    active: t,
    children: i
  } = s, a = p(s, [
    "size",
    "variant",
    "selected",
    "active",
    "children"
  ]);
  return /* @__PURE__ */ je.createElement(Ln, n({ size: o }, a), je.Children.map(i, (d) => je.isValidElement(d) ? je.cloneElement(d, { size: o, variant: e, selected: r, active: t }) : d));
}, Ep = Pp;

// src/components/Select/Select.tsx
import V from "react";

// src/components/Select/Select.styles.ts
import Bn from "styled-components";
var An = c(Lo), Dn = Qo, Fn = Bn.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`, Wn = Bn.div`
  display: flex;
  align-items: center;
`;

// src/components/Select/Select.tsx
var Ip = (B) => {
  var y = B, {
    label: o,
    helperText: e,
    autoSize: r = !1,
    autoFocus: t = !1,
    disabled: i = !1,
    locked: a = !1,
    error: l = !1,
    required: s = !1,
    fullWidth: d = !1,
    placeholder: v = "Select",
    placement: g = "bottom-start",
    sameWidth: f = !0,
    inline: u,
    startAdornment: h,
    endAdornment: x,
    value: $,
    renderValue: L,
    options: E = [],
    renderOption: M,
    closeOnSelect: C = !0,
    appendTo: I,
    size: m,
    maxHeight: b,
    maxWidth: w,
    fieldProps: q
  } = y, P = p(y, [
    "label",
    "helperText",
    "autoSize",
    "autoFocus",
    "disabled",
    "locked",
    "error",
    "required",
    "fullWidth",
    "placeholder",
    "placement",
    "sameWidth",
    "inline",
    "startAdornment",
    "endAdornment",
    "value",
    "renderValue",
    "options",
    "renderOption",
    "closeOnSelect",
    "appendTo",
    "size",
    "maxHeight",
    "maxWidth",
    "fieldProps"
  ]);
  let k = V.useRef(null), [F] = V.useState(wo(o)), [H, z] = V.useState(t), A = !(i || a);
  return /* @__PURE__ */ V.createElement(V.Fragment, null, /* @__PURE__ */ V.createElement(
    xo,
    {
      id: "overflow-menu",
      appendTo: I,
      disabled: !A,
      closeOnSelect: C,
      defaultOpen: t,
      onClose: () => {
        var S;
        (S = P.onBlur) == null || S.call(P), z(!1);
      },
      placement: g,
      sameWidth: f,
      maxHeight: b,
      maxWidth: w,
      openerWidth: u ? "max-content" : d ? "100%" : "auto",
      opener: ({ isOpen: S }) => /* @__PURE__ */ V.createElement(Dn, T(n({ fullWidth: d }, P), { onClick: () => z(!0) }), !!o && /* @__PURE__ */ V.createElement("label", { htmlFor: F }, /* @__PURE__ */ V.createElement(uo, { color: A ? "body" : "placeholder" }, o, " ", s && /* @__PURE__ */ V.createElement(V.Fragment, null, "*"))), /* @__PURE__ */ V.createElement(
        An,
        n({
          role: "listbox",
          ref: k,
          size: m,
          autoSize: r,
          disabled: !A,
          error: l,
          focus: H,
          onClick: () => {
            var W;
            return (W = k == null ? void 0 : k.current) == null ? void 0 : W.focus();
          }
        }, q),
        h,
        /* @__PURE__ */ V.createElement(Fn, null, $ != null ? L($) : /* @__PURE__ */ V.createElement(Xo, null, v)),
        x,
        /* @__PURE__ */ V.createElement(Wn, null, /* @__PURE__ */ V.createElement(Q, { open: S, locked: a, size: m }))
      ))
    },
    E.map(M)
  ), !!e && /* @__PURE__ */ V.createElement(
    D,
    {
      variant: "body4",
      marginTop: 0.5,
      color: l ? "error" : A ? "passive" : "placeholder"
    },
    e
  ));
}, Mp = c(Ip);

// src/components/SelectionPill/SelectionPill.tsx
import zn from "react";

// src/components/SelectionPill/SelectionPill.styles.ts
import Lp, { css as Hn } from "styled-components";
var On = Lp.div`
  display: inline-flex;
  align-items: center;
  border: 1px solid ${({ theme: o }) => o.mosaiq.colors.placeholder};
  border-radius: ${({ theme: o }) => o.mosaiq.spacing(3.5)}px;
  color: ${({ theme: o }) => o.mosaiq.colors.title};
  cursor: pointer;
  padding: ${({ theme: o }) => o.mosaiq.spacing(1.5)}px;

  ${D} {
    line-height: 1;
  }

  ${({ selected: o, theme: e }) => o ? Hn`
          background-color: ${e.mosaiq.colors.black};
          border-color: ${e.mosaiq.colors.black};
          color: ${e.mosaiq.colors.white};
        ` : Hn`
          &:hover {
            background-color: ${({ theme: r }) => r.mosaiq.colors.grey20};
            border-color: ${({ theme: r }) => r.mosaiq.colors.grey20};
          }
        `};
`;

// src/components/SelectionPill/SelectionPill.tsx
var Nn = c(
  (i) => {
    var a = i, { selected: o = !1, startAdornment: e, children: r } = a, t = p(a, ["selected", "startAdornment", "children"]);
    return /* @__PURE__ */ zn.createElement(On, n({ role: "button", selected: o }, t), e, /* @__PURE__ */ zn.createElement(D, { variant: "title5", ellipsis: { lines: 1 }, padding: [0, 1] }, r));
  }
);
Nn.displayName = "SelectionPill";
var Bp = Nn;

// src/components/Skeleton/Skeleton.tsx
import Dp from "react";

// src/components/Skeleton/Skeleton.styles.ts
import Ap, { css as Ge } from "styled-components";
var _n = Ap.div`
  ${({ theme: o, width: e }) => e ? Ge`
          width: ${typeof e == "string" ? e : `${o.spacing(e)}px`};
        ` : Ge`
          width: 100%;
        `}

  ${({ theme: o, height: e }) => e ? Ge`
          height: ${typeof e == "string" ? e : `${o.spacing(e)}px`};
        ` : Ge`
          height: 100%;
        `}

  background-color: ${({ theme: o }) => o.colors.grey};
  border-radius: ${({ theme: o, borderRadius: e = 1 }) => typeof e == "string" ? e : `${o.spacing(e)}px`};
  background-image: linear-gradient(
    to right,
    transparent,
    ${({ theme: o }) => o.colors.white} 50%,
    transparent
  );
  background-size: 400% 100%;
  background-repeat: no-repeat;
  background-position: 0 0;
  animation-name: shimmer;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }

    100% {
      background-position: -200% 0;
    }
  }
`;

// src/components/Skeleton/Skeleton.tsx
var jn = c((o) => /* @__PURE__ */ Dp.createElement(_n, n({}, o)));
jn.displayName = "Skeleton";
var Fp = jn;

// src/components/Spinner/Spinner.tsx
import * as Rr from "react";

// src/components/Spinner/Spinner.styles.ts
import Wp, { keyframes as Hp } from "styled-components";
var Op = Hp`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`, Gn = Wp.div`
  width: ${({ theme: o, $size: e }) => o.spacing(e)}px;
  height: ${({ theme: o, $size: e }) => o.spacing(e)}px;
  border: ${({ theme: o, $size: e, $color: r }) => `${o.spacing(e) * (e <= 5 ? 0.1 : 0.05)}px solid ${N(
  { theme: o },
  r
)}`};
  border-top-color: transparent;
  border-radius: 50%;
  animation: ${Op} 0.5208333333s linear infinite;
`;

// src/components/Spinner/Spinner.tsx
var Rn = c(
  (t) => {
    var i = t, { size: o = 5, color: e = ({ theme: a }) => a.colors.black } = i, r = p(i, ["size", "color"]);
    return /* @__PURE__ */ Rr.createElement(fo, n({ alignItems: "center", justify: "center" }, r), /* @__PURE__ */ Rr.createElement(Gn, { $size: o, $color: e }));
  }
);
Rn.displayName = "Spinner";
var zp = Rn;

// src/components/Switch/Switch.tsx
import No, { useState as Np, useEffect as _p } from "react";

// src/components/Switch/Switch.styles.ts
import Ue, { css as bo } from "styled-components";
var Re = Ue.div`
  height: 10px;
  width: 10px;
  background-color: ${({ theme: o }) => o.mosaiq.colors.white};
  border-radius: 50%;
  transform: translateX(0);
  transition: transform 200ms ease;
`, Ve = Ue.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  background-color: ${({ theme: o }) => o.mosaiq.colors.grey60};
  border: 1px solid ${({ theme: o }) => o.mosaiq.colors.grey60};
  border-radius: ${({ theme: o }) => o.spacing(1)}px;
  min-width: ${({ theme: o }) => o.spacing(3)}px;
  min-height: ${({ theme: o }) => o.spacing(2)}px;
  max-width: ${({ theme: o }) => o.spacing(3)}px;
  max-height: ${({ theme: o }) => o.spacing(2)}px;
  padding: ${({ theme: o }) => o.spacing(0.25)}px;
`, Vn = Ue(Co)`
  gap: ${({ theme: o }) => o.mosaiq.spacing(1.5)}px;

  ${Ve} {
    ${(o) => {
  let { active: e, disabled: r, theme: t } = o;
  return r ? bo`
          background-color: ${t.mosaiq.colors.grey};
          border-color: ${t.mosaiq.colors.grey60};

          ${Re} {
            ${e ? bo`
                  background-color: ${t.mosaiq.colors.placeholder};
                  transform: translateX(8px);
                ` : bo`
                  background-color: ${t.mosaiq.colors.grey60};
                `}
          }
        ` : e ? bo`
          background-color: ${o.activeColor ? N(o, o.activeColor, "colors") : t.mosaiq.colors.black};
          border-color: ${o.activeColor ? N(o, o.activeColor, "colors") : t.mosaiq.colors.black};

          ${Re} {
            transform: translateX(8px);
          }
        ` : null;
}}
  }

  ${({ flex: o }) => o && bo`
      flex: 1;
      width: 100%;
    `}

  ${({ inverted: o }) => o && bo`
      flex-direction: row-reverse;
    `}

  &:hover {
    ${({ active: o, disabled: e, theme: r }) => !e && !o && bo`
        ${Ve} {
          background-color: ${o ? r.mosaiq.colors.passive : r.mosaiq.colors.placeholder};
          border-color: ${o ? r.mosaiq.colors.passive : r.mosaiq.colors.placeholder};
        }
      `};
  }
`, Un = Ue.div`
  display: flex;
  width: 100%;
  align-items: center;
  ${({ inline: o }) => o ? bo`
          gap: ${({ theme: e }) => e.mosaiq.spacing(1.5)}px;
        ` : bo`
          flex-wrap: wrap;
          flex-direction: column;
          align-items: flex-start;
        `}
`;

// src/components/Switch/Switch.tsx
var jp = c(
  (h) => {
    var x = h, {
      active: o,
      disabled: e = !1,
      label: r,
      helperText: t,
      innerRef: i,
      onChange: a,
      inputProps: l,
      autoFocus: s = !1,
      inline: d = !0,
      inverted: v = !1,
      startAdornment: g,
      endAdornment: f
    } = x, u = p(x, [
      "active",
      "disabled",
      "label",
      "helperText",
      "innerRef",
      "onChange",
      "inputProps",
      "autoFocus",
      "inline",
      "inverted",
      "startAdornment",
      "endAdornment"
    ]);
    let [$, L] = Np(!!o);
    return _p(() => L(!!o), [o]), /* @__PURE__ */ No.createElement(
      Vn,
      n({
        active: $,
        disabled: e,
        hasLabel: !!r,
        inverted: v
      }, u),
      /* @__PURE__ */ No.createElement(Ve, null, /* @__PURE__ */ No.createElement(Re, null), /* @__PURE__ */ No.createElement(
        "input",
        T(n({
          type: "checkbox",
          disabled: e,
          autoFocus: s
        }, l), {
          ref: i,
          onChange: (E) => {
            o === void 0 && L(E.target.checked), a == null || a(E);
          },
          checked: $
        })
      )),
      !!g && g,
      (!!r || !!t) && /* @__PURE__ */ No.createElement(Un, { inline: d }, !!r && /* @__PURE__ */ No.createElement(
        D,
        {
          ellipsis: { lines: 1 },
          variant: "body2",
          color: e ? "placeholder" : "body",
          fontWeight: 500
        },
        r
      ), !!t && /* @__PURE__ */ No.createElement(
        D,
        {
          ellipsis: { lines: 1 },
          variant: "body4",
          color: e ? "placeholder" : "passive",
          italic: !0
        },
        t
      )),
      !!f && f
    );
  }
), Gp = jp;

// src/components/Table/Table.tsx
import X, { useMemo as rm, useRef as tm } from "react";
import { useTable as im, useExpanded as nm, useRowSelect as am, useSortBy as sm } from "react-table";
import { DragDropContext as lm } from "react-beautiful-dnd";
import { useSticky as pm } from "react-table-sticky";

// src/components/MultiSelectionMenu/MultiSelectionMenu.tsx
import re from "react";
import { SelectionAll as Vp } from "phosphor-react";

// src/components/MultiSelectionMenu/MultiSelectionMenu.styles.tsx
import Rp from "styled-components";
var Kn = Rp(ce)`
  position: fixed;
  bottom: ${({ theme: o }) => o.mosaiq.spacing(4)}px;
  z-index: ${({ theme: o }) => o.mosaiq.zIndexes.navsidebar - 1};
  height: 45px;
  border-radius: ${({ theme: o }) => o.mosaiq.spacing(1)}px;
  background-color: ${({ theme: o }) => o.mosaiq.colors.black};
  color: ${({ theme: o }) => o.mosaiq.colors.white}px;
  left: ${({ offset: o }) => `calc(50% + ${o}px)`};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme: o }) => o.mosaiq.spacing(1)}px;
  transform: ${({ offset: o }) => `translateX(calc(-50% - ${o / 2}px))`};
`;

// src/components/MultiSelectionMenu/MultiSelectionMenu.tsx
var Up = ({
  selectedIds: o,
  options: e = [],
  onCancelSelection: r,
  onSelectAll: t,
  offset: i = 80
}) => /* @__PURE__ */ re.createElement(Kn, { elevation: 2, minWidth: 40, offset: i, padding: [1, 2] }, /* @__PURE__ */ re.createElement(D, { variant: "body3", color: "white", fontWeight: 500 }, o.length, " ", o.length > 1 ? "items" : "item", " selected"), /* @__PURE__ */ re.createElement(
  O,
  {
    variant: "primary",
    startAdornment: /* @__PURE__ */ re.createElement(Vp, { size: 16, color: R.colors.passive }),
    onClick: t
  },
  "Select All"
), e.map((a) => /* @__PURE__ */ re.createElement(
  O,
  {
    key: a.text,
    variant: "primary",
    startAdornment: a.icon,
    onClick: () => {
      var l;
      return (l = a.action) == null ? void 0 : l.call(a, o);
    }
  },
  a.text
)), /* @__PURE__ */ re.createElement(O, { variant: "primary", onClick: r }, "Cancel")), Vr = Up;

// src/components/MultiSelectionMenu/MultiSelectionMenu.stories.tsx
import { Archive as Kp, Trash as Xp } from "phosphor-react";
import Xn from "react";
var Qn = {
  selectedIds: ["288389893h9d9ud92jdj", "sdhksd9u9wkskjljfk"],
  onCancelSelection: () => {
    console.log("cancel selection clicked");
  },
  onSelectAll: () => {
    console.log("select all clicked");
  }
}, cw = {
  args: n({}, Qn)
}, dw = {
  args: T(n({}, Qn), {
    options: [
      {
        text: "Archive",
        icon: /* @__PURE__ */ Xn.createElement(Kp, { size: 16, color: R.colors.passive }),
        action: () => {
          console.log("option  clicked");
        }
      },
      {
        text: "Remove",
        icon: /* @__PURE__ */ Xn.createElement(Xp, { size: 16, color: R.colors.passive }),
        action: () => {
          console.log("option  clicked");
        }
      }
    ]
  })
};

// src/components/Table/Table.styles.ts
import ye, { css as K } from "styled-components";
import { ellipsis as Qp } from "polished";
var Jn = ye.th`
  ${({ onClick: o, active: e, theme: r }) => o ? K`
          cursor: pointer;

          ${!e && K`
            & > div {
              margin-left: -${r.spacing(0.5)}px;
            }
            &:hover {
              & > div {
                color: ${r.mosaiq.colors.passive};
              }
            }
          `}
        ` : K`
          cursor: default;
        `}

  & > div {
    ${Qp()}
    display: inline-flex;
    align-items: center;
    ${({ theme: o }) => o.mosaiq.typography.body4({ singleLine: !0 })}

    ${({ theme: o, active: e }) => e ? K`
            color: ${o.mosaiq.colors.body};

            svg {
              color: ${({ theme: r }) => r.mosaiq.colors.body};
            }
          ` : K`
            color: ${o.mosaiq.colors.placeholder};
          `}
  }
`, Ke = ye.thead`
  th {
    text-align: left;
    white-space: pre;
    padding-bottom: ${({ theme: o }) => o.spacing(1)}px;
    padding-left: ${({ theme: o }) => o.spacing(1)}px;
    vertical-align: middle;
  }
`, te = ye.tr`
  position: relative;

  ${({ onClick: o }) => o ? K`
          cursor: pointer;
        ` : K`
          cursor: default;
        `}

  &:last-of-type {
    border-bottom: 0 none;
    box-shadow: none;

    td {
      border-bottom: thin solid ${({ theme: o }) => o.mosaiq.colors.grey40};
    }
  }

  td {
    border-top: thin solid ${({ theme: o }) => o.mosaiq.colors.grey40};
    padding: ${({ theme: o }) => o.spacing(1.5)}px;
    vertical-align: middle;
  }

  td.showOnHover > * {
    opacity: 0;
    pointer-events: none;
    transition: 0.2s ease;
  }

  &:hover,
  &.dragging {
    td {
      border-top: thin solid ${({ theme: o }) => o.mosaiq.colors.white};
      background-color: ${({ theme: o }) => o.mosaiq.colors.grey};

      &:only-of-type {
        border-radius: ${({ theme: o }) => o.spacing(1.5)}px;
      }
      &:not(:only-of-type):first-of-type {
        border-radius: ${({ theme: o }) => `${o.spacing(1.5)}px 0px 0px ${o.spacing(1.5)}px`};
      }
      &:not(:only-of-type):last-of-type {
        border-radius: ${({ theme: o }) => `0px ${o.spacing(1.5)}px ${o.spacing(1.5)}px 0px`};
      }
    }

    td.showOnHover > * {
      opacity: 1;
      pointer-events: all;
    }

    + tr {
      td {
        border-top: thin solid ${({ theme: o }) => o.mosaiq.colors.white};
      }
    }

    &:last-of-type {
      td {
        border-bottom: thin solid ${({ theme: o }) => o.mosaiq.colors.white};
      }
    }
  }

  &.dragging {
    box-shadow: ${({ theme: o }) => o.mosaiq.elevation[1]};
    border-radius: ${({ theme: o }) => o.spacing(1.5)}px;
  }

  ${({ isSelected: o }) => !!o && K`
      td {
        border-top: thin solid ${({ theme: e }) => e.mosaiq.colors.white};
        background-color: ${({ theme: e }) => e.mosaiq.colors.sandyHeath};
        &:not(:only-of-type):nth-of-type(2) {
          border-radius: ${({ theme: e }) => `${e.spacing(1.5)}px 0px 0px ${e.spacing(1.5)}px`};
        }
        &:not(:only-of-type):last-of-type {
          border-radius: ${({ theme: e }) => `0px ${e.spacing(1.5)}px ${e.spacing(1.5)}px 0px`};
        }
      }

      td.showOnHover > * {
        opacity: 1;
        pointer-events: all;
      }

      + tr {
        td {
          border-top: thin solid ${({ theme: e }) => e.mosaiq.colors.white};
        }
      }

      &:last-of-type {
        td {
          border-bottom: thin solid ${({ theme: e }) => e.mosaiq.colors.white};
        }
      }
    `}
`, Yn = ye.table`
  ${({ theme: o, transparentBg: e }) => e ? K`
          background-color: transparent;

          ${te} {
            &:hover {
              td {
                border-top: thin solid ${o.mosaiq.colors.grey40};
                background-color: transparent;
              }

              + tr {
                td {
                  border-top: thin solid ${o.mosaiq.colors.grey40};
                }
              }

              &:last-of-type {
                td {
                  border-bottom: thin solid ${o.mosaiq.colors.grey40};
                }
              }
            }
          }
        ` : K`
          background-color: ${o.mosaiq.colors.white};
        `}

  min-width: 100%;
  max-width: 100%;
  border-collapse: separate;

  ${({ disabled: o }) => o && K`
      pointer-events: none;

      ${te} {
        cursor: default;
        pointer-events: none;
      }
    `}

  ${({ tableLayout: o }) => o && K`
      table-layout: ${o};
    `}

  ${({ selectTable: o }) => o && K`
      ${te}, ${Ke} {
        &:hover {
          td {
            &:not(:only-of-type):nth-of-type(2) {
              border-radius: ${({ theme: e }) => `${e.spacing(1.5)}px 0px 0px ${e.spacing(1.5)}px`};
            }
            &:not(:only-of-type):last-of-type {
              border-radius: ${({ theme: e }) => `0px ${e.spacing(1.5)}px ${e.spacing(1.5)}px 0px`};
            }
          }
        }
        th:first-child {
          padding-bottom: ${({ theme: e }) => e.spacing(0.25)}px;
        }
        td:first-child,
        th:first-child {
          padding-right: ${({ theme: e }) => e.spacing(0.75)}px;
          border: none;
          background: none;
          & > * {
            opacity: 0;
            pointer-events: none;
          }
        }
        &:hover {
          td:first-child > *,
          th:first-child > * {
            opacity: 1;
            pointer-events: all;
          }
        }
      }
    `}

    ${({ hasSelection: o }) => o && K`
      ${te}, ${Ke} {
        td:first-child > *,
        th:first-child > * {
          opacity: 1;
          pointer-events: all;
        }
      }
    `}

  &.sticky {
    overflow: scroll;
    .header,
    .footer {
      position: sticky;
      z-index: 1;
      width: fit-content;
    }

    .header {
      top: 0;
      box-shadow: 0px 3px 3px ${({ theme: o }) => o.mosaiq.colors.passive};
    }

    .footer {
      bottom: 0;
      box-shadow: 0px -3px 3px ${({ theme: o }) => o.mosaiq.colors.passive};
    }

    .body {
      position: relative;
      z-index: 0;
    }

    [data-sticky-td] {
      position: sticky;
    }
  }
`, Zn = ye.div`
  position: relative;
  overflow-x: auto;
  ${({ selectTable: o }) => o && K`
      margin-left: ${({ theme: e }) => -e.spacing(4.375)}px;
    `}
`;

// src/components/Table/TableHeaderCell.tsx
import Eo from "react";
import { ArrowDown as Jp, ArrowUp as Yp } from "phosphor-react";
var Ur = {
  asc: /* @__PURE__ */ Eo.createElement(Yp, { weight: "bold", size: 14 }),
  desc: /* @__PURE__ */ Eo.createElement(Jp, { weight: "bold", size: 14 })
};
function Zp(s) {
  var d = s, {
    header: o,
    columns: e,
    sort: r,
    sortable: t,
    onSortChange: i,
    index: a
  } = d, l = p(d, [
    "header",
    "columns",
    "sort",
    "sortable",
    "onSortChange",
    "index"
  ]);
  let L = o.getHeaderProps(), { key: v } = L, g = p(L, ["key"]), f = e[a], u = f == null ? void 0 : f.accessor, h = !r || !u ? o.isSorted ? o.isSortedDesc ? "desc" : "asc" : null : f.customSortKey ? r[f.customSortKey] : r == null ? void 0 : r[u], x = h ? Ur[h] : null, $ = (E, M) => {
    if (!i) return;
    let C = { [u]: E };
    f.customSortKey ? i({ [f.customSortKey]: E }, M) : i(C, M);
  };
  return /* @__PURE__ */ Eo.createElement(Jn, T(n(n({}, l), g), { active: !!h }), /* @__PURE__ */ Eo.createElement("div", null, t && o.sortable ? /* @__PURE__ */ Eo.createElement(
    Or,
    {
      appendTo: document.body,
      opener: ({ isOpen: E }) => /* @__PURE__ */ Eo.createElement(
        O,
        n({
          size: "small",
          variant: "secondary",
          active: !!h,
          selected: E,
          endAdornment: x,
          disabled: !i && !f.sortable
        }, g),
        o.render("Header")
      )
    },
    /* @__PURE__ */ Eo.createElement(
      _,
      {
        size: "small",
        primaryText: "Sort ascending",
        avatar: Ur.asc,
        active: h === "asc",
        onClick: (E) => $("asc", E)
      }
    ),
    /* @__PURE__ */ Eo.createElement(
      _,
      {
        size: "small",
        primaryText: "Sort descending",
        avatar: Ur.desc,
        active: h === "desc",
        onClick: (E) => $("desc", E)
      }
    )
  ) : o.render("Header")));
}
var oa = Zp;

// src/components/Table/utils.tsx
import ea from "react";
var ra = (o) => o ? [
  {
    id: "selection",
    Header: (e) => /* @__PURE__ */ ea.createElement(
      Fe,
      T(n({}, e.getToggleAllRowsSelectedProps()), {
        onClick: (r) => r.stopPropagation(),
        marginLeft: 0.5
      })
    ),
    Cell: ({ row: e }) => /* @__PURE__ */ ea.createElement(Fe, T(n({}, e.getToggleRowSelectedProps()), { onClick: (r) => r.stopPropagation() })),
    minWidth: 20,
    width: 20
  }
] : [];

// src/components/utils/ConditionalDraggable.tsx
import Kr from "react";
import { Draggable as om } from "react-beautiful-dnd";
var ta = (t) => {
  var i = t, {
    isDraggable: o,
    children: e
  } = i, r = p(i, [
    "isDraggable",
    "children"
  ]);
  return o ? /* @__PURE__ */ Kr.createElement(om, n({}, r), e) : /* @__PURE__ */ Kr.createElement(Kr.Fragment, null, e());
};

// src/components/utils/ConditionalDroppable.tsx
import Xr from "react";
import { Droppable as em } from "react-beautiful-dnd";
var ia = (t) => {
  var i = t, {
    isDraggable: o,
    children: e
  } = i, r = p(i, [
    "isDraggable",
    "children"
  ]);
  return o ? /* @__PURE__ */ Xr.createElement(em, n({}, r), e) : /* @__PURE__ */ Xr.createElement(Xr.Fragment, null, e());
};

// src/components/Table/Table.tsx
function mm(y) {
  var k = y, {
    columns: o,
    data: e = [],
    sortable: r = !0,
    sort: t,
    onSortChange: i,
    onCellClick: a,
    onCellEnter: l,
    onCellLeave: s,
    onRowClick: d,
    onRowEnter: v,
    onRowLeave: g,
    getRowId: f,
    getSubRows: u,
    headerless: h = !1,
    disabled: x = !1,
    onDragEnd: $,
    droppableId: L = "table",
    transparentBg: E = !1,
    tableLayout: M,
    rowProps: C,
    initialState: I,
    autoResetExpanded: m = !1,
    showSelection: b = !1,
    selectionOptions: w,
    skipInternalDndContext: q = !1,
    customOptions: P
  } = k, B = p(k, [
    "columns",
    "data",
    "sortable",
    "sort",
    "onSortChange",
    "onCellClick",
    "onCellEnter",
    "onCellLeave",
    "onRowClick",
    "onRowEnter",
    "onRowLeave",
    "getRowId",
    "getSubRows",
    "headerless",
    "disabled",
    "onDragEnd",
    "droppableId",
    "transparentBg",
    "tableLayout",
    "rowProps",
    "initialState",
    "autoResetExpanded",
    "showSelection",
    "selectionOptions",
    "skipInternalDndContext",
    "customOptions"
  ]);
  let F = rm(
    () => [...ra(b), ...o],
    [b, , o]
  ), {
    getTableProps: H,
    getTableBodyProps: z,
    headerGroups: A,
    rows: S,
    prepareRow: W,
    state: { selectedRowIds: yo },
    toggleAllRowsSelected: Io
  } = im(
    n({
      columns: F,
      data: e,
      initialState: I,
      getRowId: f,
      getSubRows: u,
      autoResetExpanded: m
    }, P),
    sm,
    nm,
    pm,
    am
  ), jo = tm(null), Ze = Object.keys(yo), ba = (ho, j) => n(n({}, j), ho && jo.current ? {
    display: "table",
    width: jo.current.clientWidth
  } : {});
  if (!(e != null && e.length))
    return null;
  let or = !!$ || q, Yr = /* @__PURE__ */ X.createElement(Zn, { ref: jo, selectTable: b }, /* @__PURE__ */ X.createElement(ia, { droppableId: L, isDraggable: or }, (ho) => /* @__PURE__ */ X.createElement(
    Yn,
    n(T(n({
      className: "sticky",
      tableLayout: M,
      disabled: x
    }, H()), {
      transparentBg: E,
      ref: ho == null ? void 0 : ho.innerRef,
      hasSelection: !!Ze.length,
      selectTable: b
    }), B),
    /* @__PURE__ */ X.createElement("colgroup", null, F.map(({ accessor: j, width: $o, minWidth: Go, maxWidth: Ro, id: mo }, Mo) => {
      var U;
      return /* @__PURE__ */ X.createElement(
        "col",
        {
          span: 1,
          key: typeof j == "function" ? mo : (U = j == null ? void 0 : j.toString()) != null ? U : Mo,
          style: { width: $o, minWidth: Go, maxWidth: Ro }
        }
      );
    })),
    !h && /* @__PURE__ */ X.createElement(Ke, null, A.map((j) => {
      let Ro = j.getHeaderGroupProps(), { key: $o } = Ro, Go = p(Ro, ["key"]);
      return /* @__PURE__ */ X.createElement("tr", n({ key: $o }, Go), j.headers.map((mo, Mo) => /* @__PURE__ */ X.createElement(
        oa,
        T(n({}, mo.getHeaderProps(
          F[Mo].sortable ? mo.getSortByToggleProps() : void 0
        )), {
          key: mo.getHeaderProps().key,
          header: mo,
          columns: F,
          sort: t,
          sortable: r,
          onSortChange: i,
          index: Mo
        })
      )));
    })),
    /* @__PURE__ */ X.createElement("tbody", n({}, z()), S.map((j, $o) => {
      var Mo;
      W(j);
      let mo = j.getRowProps(), { key: Go } = mo, Ro = p(mo, ["key"]);
      return /* @__PURE__ */ X.createElement(
        ta,
        {
          key: Go,
          draggableId: (Mo = j.id) != null ? Mo : $o,
          index: $o,
          isDraggable: or
        },
        (U, Vo) => {
          var Zr;
          return /* @__PURE__ */ X.createElement(
            te,
            T(n(n(n({
              isSelected: j.isSelected,
              key: Go
            }, (Zr = C == null ? void 0 : C[$o]) != null ? Zr : {}), Ro), or && T(n(n({
              ref: U == null ? void 0 : U.innerRef
            }, U == null ? void 0 : U.draggableProps), U == null ? void 0 : U.dragHandleProps), {
              className: Vo != null && Vo.isDragging ? "dragging" : void 0,
              style: ba(
                (Vo == null ? void 0 : Vo.isDragging) || !1,
                U == null ? void 0 : U.draggableProps.style
              )
            })), {
              onMouseEnter: v ? (ro) => {
                v(j, ro);
              } : void 0,
              onMouseLeave: g ? (ro) => {
                g(j, ro);
              } : void 0,
              onClick: d ? (ro) => {
                d(j, ro);
              } : void 0
            }),
            j.cells.map((ro, co) => {
              var rt, tt, it;
              let et = ro.getCellProps(), { key: ya, style: ha } = et, ot = p(et, ["key", "style"]);
              return /* @__PURE__ */ X.createElement(
                "td",
                {
                  key: ya,
                  style: n({
                    minWidth: F[co].minWidth,
                    maxWidth: F[co].maxWidth,
                    width: F[co].width
                  }, ha),
                  className: ot.className || (rt = F[co]) != null && rt.showOnHover ? `${(tt = ot.className) != null ? tt : ""} ${(it = F[co]) != null && it.showOnHover ? "showOnHover" : ""}` : void 0,
                  onMouseEnter: l ? (ie) => l(ro, co, ie) : void 0,
                  onMouseLeave: s ? (ie) => s(ro, co, ie) : void 0,
                  onClick: a ? (ie) => a(ro, co, ie) : void 0,
                  "data-testid": `table-${$o}-${co}`
                },
                ro.render("Cell", { provided: U })
              );
            })
          );
        }
      );
    }), ho == null ? void 0 : ho.placeholder)
  )), !!Ze.length && /* @__PURE__ */ X.createElement(
    Vr,
    {
      selectedIds: Ze,
      options: w,
      onSelectAll: () => Io(!0),
      onCancelSelection: () => Io(!1)
    }
  ));
  return $ && !q ? /* @__PURE__ */ X.createElement(lm, { onDragEnd: $ }, Yr) : Yr;
}
var cm = mm;

// src/components/Table/index.ts
import { DragDropContext as fC, Droppable as uC } from "react-beautiful-dnd";

// src/components/Tabs/Tabs.tsx
import eo, {
  useRef as dm,
  useState as sa,
  useMemo as Jr,
  useLayoutEffect as fm,
  useEffect as um
} from "react";

// src/components/Tabs/Tabs.styles.ts
import Qe, { css as lo } from "styled-components";
var Qr = Qe.div`
  position: sticky;

  ${({ direction: o, theme: e }) => o === "start" ? lo`
        left: 0;
        padding-right: ${e.spacing(2)}px;
      ` : lo`
      right: 0;
      margin-left: auto;
      padding-left: ${e.spacing(2)}px;
    `}
`, Xe = Qe.span`
  color: ${({ theme: o }) => o.mosaiq.colors.placeholder};
`, na = Qe.div`
  display: flex;
  gap: ${({ theme: o }) => o.mosaiq.spacing(0.75)}px;
  align-items: center;

  ${({ active: o }) => !o && lo`
      cursor: pointer;
    `}

  ${({ size: o, theme: e, active: r }) => {
  switch (o) {
    case "small":
    case "large":
    case "xlarge":
      return r ? lo`
              color: ${e.mosaiq.colors.title};

              ${Xe} {
                color: ${e.mosaiq.colors.passive};
              }
            ` : lo`
            color: ${({ theme: t }) => t.mosaiq.colors.placeholder};

            &:hover {
              color: ${({ theme: t }) => t.mosaiq.colors.passive};
            }
          }
        `;
    default:
      return lo`
          padding: ${e.mosaiq.spacing(1)}px ${e.mosaiq.spacing(1.25)}px;
          ${({ theme: t }) => t.mosaiq.mixins.squircle({ borderRadius: t.mosaiq.spacing(1) })};

          ${r ? lo`
                color: ${e.mosaiq.colors.title};
                background-color: ${({ theme: t }) => t.mosaiq.colors.grey};

                ${Xe} {
                  color: ${e.mosaiq.colors.passive};
                }
              ` : lo`
                color: ${e.mosaiq.colors.body};
              `}

          &:hover {
            background-color: ${({ theme: t }) => t.mosaiq.colors.grey20};
          }
        `;
  }
}}

  ${({ disabled: o, theme: e }) => o && lo`
      color: ${e.mosaiq.colors.placeholder};
      pointer-events: none;
    `}

    & svg {
    color: ${({ theme: o }) => o.mosaiq.colors.passive};
  }

  ${({ fullWidth: o }) => o && lo`
      width: 100%;
      position: relative;
      padding: 0;
      & > span {
        display: block;
        width: 100%;
      }
    `}
`, aa = Qe.div`
  display: flex;
  align-items: center;
  overflow-x: ${({ collapsible: o }) => o ? "hidden" : "auto"};
  padding-right: ${({ theme: o, isCollapsed: e }) => e ? o.mosaiq.spacing(5) : 0}px;

  &::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }

  & > ${D} {
    min-width: max-content;

    &:not(:last-of-type) {
      margin-right: ${({ size: o, theme: e }) => {
  switch (o) {
    case "xlarge":
      return e.mosaiq.spacing(4);
    case "large":
      return e.mosaiq.spacing(3);
    // small and regular
    default:
      return e.mosaiq.spacing(2);
  }
}}px;
    }
  }

  & .hidden {
    opacity: 0;
    pointer-events: none;
    order: 99;
  }
`;

// src/components/Tabs/Tabs.tsx
var la = c(
  (g) => {
    var f = g, {
      tabs: o,
      value: e,
      onTabChange: r,
      size: t = "regular",
      innerRef: i,
      startAdornment: a,
      endAdornment: l,
      collapsible: s = !1,
      fullWidth: d = !1
    } = f, v = p(f, [
      "tabs",
      "value",
      "onTabChange",
      "size",
      "innerRef",
      "startAdornment",
      "endAdornment",
      "collapsible",
      "fullWidth"
    ]);
    let u = dm(), [h, x] = sa(0), { headers: $, contents: L } = Jr(() => {
      let b = [], w = [];
      return o.forEach((A, z) => {
        var S = A, { key: q, header: P, disabled: B, meta: y, content: k, alt: F } = S, H = p(S, ["key", "header", "disabled", "meta", "content", "alt"]);
        b = [
          ...b,
          n({
            key: q,
            label: P,
            disabled: B != null ? B : !1,
            meta: y,
            alt: F,
            index: z
          }, H)
        ], w = [...w, k];
      }), { headers: b, contents: w };
    }, [o]), E = Jr(() => L[h], [h, L]), M = Jr(() => {
      switch (t) {
        case "xlarge":
          return "title3";
        case "large":
          return "title6";
        case "small":
          return "body4";
        default:
          return "body3";
      }
    }, [t]);
    um(() => {
      typeof e == "number" && x(e);
    }, [e]);
    let [C, I] = sa([]);
    fm(() => {
      var q, P;
      if (!s || !("IntersectionObserver" in window)) return;
      let b = (B) => {
        let y = [], k = [];
        B.forEach((F) => {
          let H = F.target.dataset.tabid;
          F.intersectionRatio < 1 ? (F.target.classList.add("hidden"), k.push(+H)) : (F.target.classList.remove("hidden"), y.push(+H));
        }), I((F) => {
          let H = /* @__PURE__ */ new Set([...F.map(({ index: z }) => z)]);
          return y.forEach((z) => H.delete(z)), k.forEach((z) => H.add(z)), $.filter(
            ({ index: z, alt: A, label: S }) => H.has(z) && (!!A || typeof S == "string")
          );
        });
      }, w = new IntersectionObserver(b, {
        threshold: [0.1, 1],
        root: u.current
      });
      return Array.from((P = (q = u.current) == null ? void 0 : q.children) != null ? P : []).forEach((B) => {
        B.dataset.tabid && w.observe(B);
      }), () => w.disconnect();
    }, [s, $]);
    let m = s && !!C.length;
    return /* @__PURE__ */ eo.createElement("div", n({ ref: i }, v), /* @__PURE__ */ eo.createElement(aa, { ref: u, size: t, collapsible: s, isCollapsed: m }, !!a && /* @__PURE__ */ eo.createElement(Qr, { direction: "start" }, a), $.map((F, k) => {
      var H = F, { key: b, label: w, meta: q, disabled: P, index: B } = H, y = p(H, ["key", "label", "meta", "disabled", "index"]);
      return /* @__PURE__ */ eo.createElement(
        D,
        n({
          key: k,
          fontWeight: t !== "xlarge" ? 500 : 400,
          variant: M,
          ellipsis: { lines: 1 },
          "data-testid": "tabHeader",
          "data-tabid": B,
          style: { flex: d ? 1 : 0 }
        }, y),
        /* @__PURE__ */ eo.createElement(
          na,
          {
            size: t,
            disabled: P,
            active: h === k,
            "data-testid": b ? `tab-${b}` : void 0,
            fullWidth: d,
            onClick: () => {
              x(k), r == null || r(k);
            }
          },
          /* @__PURE__ */ eo.createElement("span", null, w),
          !!q && /* @__PURE__ */ eo.createElement(Xe, null, q)
        )
      );
    }), m && /* @__PURE__ */ eo.createElement(
      xo,
      {
        opener: ({ isOpen: b }) => /* @__PURE__ */ eo.createElement(so, { size: "small", variant: "secondary", active: !0, "data-tabid": $.length }, /* @__PURE__ */ eo.createElement(Q, { open: b }))
      },
      C.map(({ label: b, alt: w, index: q }) => /* @__PURE__ */ eo.createElement(
        Fo,
        {
          key: q,
          tabIndex: q,
          primaryText: w != null ? w : b,
          onClick: () => {
            x(q), r == null || r(q);
          }
        }
      ))
    ), !!l && /* @__PURE__ */ eo.createElement(Qr, { direction: "end" }, l)), E);
  }
);
la.displayName = "Tabs";
var gm = la;

// src/components/Textarea/Textarea.tsx
import po, { useRef as bm, useEffect as ym, useCallback as hm, useLayoutEffect as $m } from "react";

// src/components/Textarea/Textarea.styles.ts
import xm, { css as _o } from "styled-components";
var pa = xm.div`
  display: flex;
  flex-direction: column;

  ${({ width: o, theme: e }) => !!o && _o`
      width: ${typeof o == "number" ? `${e.spacing(o)}px` : o};
    `}

  textarea {
    width: 100%;
    font-family: ${({ theme: o }) => o.mosaiq.fonts.main};
    padding: ${({ theme: o }) => o.spacing(1.5)}px;
    margin: 0;
    outline: none;

    box-shadow: ${({ theme: o, elevation: e }) => e ? o.mosaiq.elevation[e] : "0px 1px 3px 0px rgba(0, 0, 0, 0.1)"};
    border-width: 2px;
    border-style: solid;
    border-color: ${({ theme: o }) => o.mosaiq.colors.grey60};
    border-radius: ${({ theme: o }) => o.spacing(1.25)}px;

    transition: border-color 0.2s ease-out;

    ${({ theme: o }) => o.mosaiq.typography.body3()}

    ${({ resize: o }) => !o && _o`
        resize: none;
      `}

    &::placeholder {
      color: ${({ theme: o }) => o.mosaiq.colors.placeholder};
    }

    ${({ theme: o, error: e, disabled: r, borderless: t }) => t ? _o`
          border: none;
          box-shadow: none;
          padding-left: 0;

          ${e && _o`
            color: ${({ theme: i }) => i.mosaiq.colors.error};

            &::placeholder {
              color: ${({ theme: i }) => i.mosaiq.colors.error};
            }
          `}
        ` : e ? _o`
          border-color: ${o.mosaiq.colors.error};
        ` : r ? _o`
          background: ${o.mosaiq.colors.grey};
          border-color: ${o.mosaiq.colors.grey60};
        ` : _o`
        &:hover {
          border-color: ${o.mosaiq.colors.placeholder};
        }

        &:focus {
          border-color: ${o.mosaiq.colors.black};
        }
      `}
  }
`;

// src/components/Textarea/Textarea.tsx
var vm = ({ hasLabel: o, children: e }) => o ? /* @__PURE__ */ po.createElement("label", null, e) : /* @__PURE__ */ po.createElement(po.Fragment, null, e), ma = c(
  ($) => {
    var L = $, {
      innerRef: o,
      autoSize: e = !1,
      autoFocus: r = !1,
      resize: t = !1,
      label: i,
      helperText: a,
      textareaProps: l = {},
      disabled: s = !1,
      error: d = !1,
      required: v = !1,
      borderless: g = !1,
      width: f,
      placeholder: u,
      minHeight: h
    } = L, x = p(L, [
      "innerRef",
      "autoSize",
      "autoFocus",
      "resize",
      "label",
      "helperText",
      "textareaProps",
      "disabled",
      "error",
      "required",
      "borderless",
      "width",
      "placeholder",
      "minHeight"
    ]);
    let E = bm(null), b = l, { onChange: M, elevation: C } = b, I = p(b, ["onChange", "elevation"]), m = hm(() => {
      var P;
      let w = (P = E.current) == null ? void 0 : P.querySelector("textarea");
      if (!w)
        return;
      w.style.height = "1px";
      let q = w.scrollHeight;
      w.style.height = (h ? q > h ? q : h : 2 + q) + "px";
    }, [E.current, h]);
    return ym(() => {
      var q, P, B, y;
      let w = (q = E.current) == null ? void 0 : q.querySelector("textarea");
      r && w && (w.setSelectionRange((P = w.value) == null ? void 0 : P.length, (B = w.value) == null ? void 0 : B.length), (y = w.focus) == null || y.call(w));
    }, [r]), $m(() => {
      e && m();
    }, [l == null ? void 0 : l.value]), /* @__PURE__ */ po.createElement(
      pa,
      n({
        ref: (w) => {
          E.current = w, o && "current" in o && (o.current = w);
        },
        disabled: s,
        resize: t,
        error: d,
        borderless: g,
        width: f,
        elevation: C
      }, x),
      /* @__PURE__ */ po.createElement(vm, { hasLabel: !!i }, !!i && /* @__PURE__ */ po.createElement(uo, { marginBottom: 0.5, color: s ? "placeholder" : "body" }, i, v && /* @__PURE__ */ po.createElement(po.Fragment, null, "*")), /* @__PURE__ */ po.createElement(
        "textarea",
        n({
          "data-testid": "textArea",
          disabled: s,
          onChange: (w) => {
            M == null || M(w), e && m();
          },
          placeholder: u
        }, I)
      )),
      !!a && /* @__PURE__ */ po.createElement(
        D,
        {
          marginTop: 0.5,
          variant: "body4",
          color: d ? "error" : s ? "placeholder" : "passive"
        },
        a
      )
    );
  }
);
ma.displayName = "Textarea";
var qm = ma;

// src/components/Toast/Toast.tsx
import Ye from "react";

// src/components/Toast/Toast.styles.ts
import Je from "styled-components";
import { rgba as wm } from "polished";
var ca = Je.div`
  display: flex;
  align-items: center;
  padding: ${({ theme: o }) => o.spacing(1)}px ${({ theme: o }) => o.spacing(1)}px
    ${({ theme: o }) => o.spacing(1)}px ${({ theme: o }) => o.spacing(1.5)}px;
  background-color: ${({ theme: o }) => wm(o.colors.black, 0.85)};
  border-radius: ${({ theme: o }) => o.spacing(1)}px;
  box-shadow:
    0px 0px 10px rgba(0, 0, 0, 0.05),
    0px 5px 10px rgba(0, 0, 0, 0.05),
    0px 2px 4px rgba(0, 0, 0, 0.05),
    0px 10px 20px rgba(0, 0, 0, 0.05);

  max-width: 480px;
  min-height: 40px;

  > *:not(:last-child) {
    margin-right: ${({ theme: o }) => o.spacing(3)}px;
  }
`, da = Je.div`
  width: 100%;
  display: flex;
  align-items: center;

  > *:not(:last-child) {
    margin-right: ${({ theme: o }) => o.spacing(1)}px;
  }

  ${({ theme: o }) => o.mosaiq.mediaQueries.screenSize({ max: "extraSmall" })`
    max-width: 100%;
  `}
`, fa = Je.div`
  color: ${({ theme: o }) => o.colors.white};
  width: max-content;
  min-width: 320px;
  padding-right: ${({ theme: o }) => o.spacing(2)}px;
  margin-left: ${({ $hasIcon: o, theme: e }) => o ? e.spacing(1) : 0};

  ${({ theme: o }) => o.mosaiq.typography.body3()};

  ${({ theme: o }) => o.mosaiq.mediaQueries.screenSize({ max: "extraSmall" })`
    min-width: unset;
  `}
`, ua = Je.div`
  display: flex;
  align-items: center;
  margin-left: auto;

  > *:not(:last-child) {
    margin-right: ${({ theme: o }) => o.spacing(0.5)}px;
  }
`;

// src/components/Toast/Toast.tsx
var ga = c(
  (l) => {
    var s = l, { icon: o, message: e, primaryAction: r, secondaryAction: t, innerRef: i } = s, a = p(s, ["icon", "message", "primaryAction", "secondaryAction", "innerRef"]);
    return /* @__PURE__ */ Ye.createElement(ca, n({ ref: i }, a), /* @__PURE__ */ Ye.createElement(da, null, o, /* @__PURE__ */ Ye.createElement(fa, { $hasIcon: !!o }, e), r || t ? /* @__PURE__ */ Ye.createElement(ua, null, r, t) : null));
  }
);
ga.displayName = "Toast";
var Cm = ga;

// src/shared/TableDepthIndicator/index.tsx
import Sm from "react";
import { useTheme as km } from "styled-components";
import { ArrowBendDownRight as Tm } from "phosphor-react";
var xa = c(
  (r) => {
    var t = r, { innerRef: o } = t, e = p(t, ["innerRef"]);
    let i = km();
    return /* @__PURE__ */ Sm.createElement(Tm, T(n({}, e), { ref: o, size: 24, color: i.mosaiq.colors.grey60 }));
  }
);
xa.displayName = "TableDepthIndicator";
var Pm = xa;
export {
  ls as Accordion,
  Mt as AccordionContainer,
  Ft as AccordionItem,
  Lt as AccordionItemContainer,
  At as AccordionItemContent,
  Bt as AccordionItemSummary,
  Ws as Autocomplete,
  ti as AutocompleteContainer,
  hr as Avatar,
  Be as AvatarContainer,
  Vs as AvatarList,
  mi as AvatarListContainer,
  Qs as Badge,
  tr as Box,
  O as Button,
  gi as ButtonContainer,
  ol as ButtonGroup,
  yi as ButtonGroupContainer,
  ll as Calendar,
  $i as CalendarWrapper,
  ce as Card,
  gl as CardAction,
  wi as CardActionContainer,
  vi as CardContainer,
  Fe as Checkbox,
  ki as CheckboxContainer,
  wr as CheckboxInput,
  Ti as CheckboxTextContainer,
  vl as Container,
  Co as ControlContainer,
  ve as ControlInput,
  cw as Default,
  Cl as Divider,
  Di as DividerWrapper,
  fC as DragDropContext,
  kl as Dropdown,
  Q as DropdownArrow,
  uC as Droppable,
  Js as EmptyButton,
  Il as Expander,
  Bl as Fab,
  Hi as FabContainer,
  Lo as Field,
  Qo as FieldContainer,
  Xo as FieldPlaceholder,
  fo as Flex,
  Dd as GlobalStyle,
  Hl as Grid,
  ji as GridContainer,
  _i as GridHeader,
  _l as GridPopover,
  Ni as GridPopoverOpener,
  Ul as IconAvatar,
  Ql as IconBadge,
  so as IconButton,
  Br as IconButtonContainer,
  pr as Input,
  zt as InputContainer,
  _t as InputField,
  sp as InputPills,
  uo as Label,
  Nt as LabelContainer,
  yn as ListFooter,
  pp as ListGroup,
  fn as ListGroupContent,
  bn as ListHeader,
  _ as ListItem,
  Pe as ListItemActions,
  Gt as ListItemAvatar,
  Rt as ListItemContainer,
  mr as ListItemContent,
  Or as ListPopover,
  xn as ListPopoverOpener,
  hp as LogarithmicProgressBar,
  ur as Menu,
  go as MenuCard,
  ko as MenuContainer,
  Fo as MenuItem,
  Ut as MenuShimmer,
  ud as MosaiqThemeProvider,
  Kn as MultiSelectionMenuContainer,
  zd as OpenerIcon,
  dw as Options,
  xo as OverflowMenu,
  Qt as OverflowMenuOpener,
  xe as Pill,
  ze as PillRemoveIcon,
  nn as PillWrapper,
  Nr as ProgressBar,
  Sn as ProgressBarContainer,
  zr as ProgressBarProgression,
  qp as Radio,
  be as RadioButton,
  kp as RadioButtonGroup,
  Pn as RadioContainer,
  Tn as RadioIcon,
  jr as RadioInput,
  Ep as SegmentedButton,
  Mp as Select,
  Wn as SelectArrow,
  Dn as SelectContainer,
  An as SelectField,
  Fn as SelectValue,
  Bp as SelectionPill,
  On as SelectionPillContainer,
  Fp as Skeleton,
  _n as SkeletonItem,
  Fa as Spacer,
  zp as Spinner,
  Gp as Switch,
  cm as Table,
  Yn as TableContainer,
  Pm as TableDepthIndicator,
  Ke as TableHeader,
  Jn as TableHeaderCellWrapper,
  te as TableRow,
  Zn as TableWrapper,
  gm as Tabs,
  aa as TabsHeader,
  Qr as TabsHeaderAdornment,
  na as TabsHeaderItem,
  Xe as TabsHeaderItemMeta,
  qm as Textarea,
  pa as TextareaContainer,
  Cm as Toast,
  ua as ToastCTAs,
  fa as ToastContent,
  da as ToastContentWrapper,
  ca as ToastWrapper,
  ue as Tooltip,
  on as TooltipContainer,
  Zi as TooltipOpener,
  D as Typography,
  Ht as TypographyWrapper,
  Fi as VerticalDividerWrapper,
  Z as avatarSizeUnitMap,
  Wo as borderSizeMap,
  le as buttonBaseStyles,
  pe as buttonBorder,
  vr as buttonColor,
  wn as calculatePercentage,
  rr as checkScreenSize,
  wo as generateId,
  pt as getTyprographyPropsByAvatarSize,
  Vl as iconBorderRadiusSizeUnitMap,
  Rl as iconSizeUnitMap,
  c as mosaiqStyled,
  R as mosaiqTheme,
  N as selfOrFunction
};
//# sourceMappingURL=index.es.js.map